import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  Json: any;
};

/** Achieved Value */
export type AchievedValue = {
  __typename?: 'AchievedValue';
  metBetObjective: Scalars['Boolean'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AdminUpdateUserPasswordInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type AdyenAchDetails = {
  __typename?: 'AdyenAchDetails';
  bankAccountType?: Maybe<Scalars['String']>;
  bankSummary?: Maybe<Scalars['String']>;
};

export type AdyenApp = {
  __typename?: 'AdyenApp';
  /** The unique identifier of this app, to submit in requests to /payments */
  id: Scalars['String'];
  /** A localized name of the app */
  name: Scalars['String'];
};

export type AdyenApplePayDetails = {
  __typename?: 'AdyenApplePayDetails';
  brand?: Maybe<Scalars['String']>;
  cardSummary?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<Scalars['String']>;
  tokenTxVariant?: Maybe<Scalars['String']>;
};

export type AdyenCardDetails = {
  __typename?: 'AdyenCardDetails';
  brand?: Maybe<Scalars['String']>;
  cardBin?: Maybe<Scalars['String']>;
  cardSummary?: Maybe<Scalars['String']>;
  fundingSource?: Maybe<Scalars['String']>;
};

export type AdyenCashappDetails = {
  __typename?: 'AdyenCashappDetails';
  cashtag?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
};

export type AdyenDetails = {
  /** Payment method data from Adyen components, converted into a string */
  paymentMethod: Scalars['String'];
  returnUrl: Scalars['String'];
};

export type AdyenGroup = {
  __typename?: 'AdyenGroup';
  /** The name of the group */
  name: Scalars['String'];
  /** Echo data to be used if the payment method is displayed as part of this group */
  paymentMethodData?: Maybe<Scalars['String']>;
  /** The unique code of the group */
  type: Scalars['String'];
};

export type AdyenIssuer = {
  __typename?: 'AdyenIssuer';
  /** A boolean value indicating whether this issuer is unavailable. Can be true whenever the issuer is offline */
  disabled: Scalars['Boolean'];
  /** The unique identifier of this issuer, to submit in requests to /payments */
  id: Scalars['String'];
  /** A localized name of the issuer */
  name: Scalars['String'];
};

export type AdyenPaymentMethodConfiguration = {
  __typename?: 'AdyenPaymentMethodConfiguration';
  clientId?: Maybe<Scalars['String']>;
  intent?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['String']>;
};

export type AdyenPaypalDetails = {
  __typename?: 'AdyenPaypalDetails';
  payerId?: Maybe<Scalars['String']>;
  paypalEmail?: Maybe<Scalars['String']>;
};

export type AdyenProviderDetails = {
  __typename?: 'AdyenProviderDetails';
  achDetails?: Maybe<AdyenAchDetails>;
  applePayDetails?: Maybe<AdyenApplePayDetails>;
  cardDetails?: Maybe<AdyenCardDetails>;
  cashappDetails?: Maybe<AdyenCashappDetails>;
  paymentMethodType: Scalars['String'];
  paypalDetails?: Maybe<AdyenPaypalDetails>;
  storedPaymentMethodId?: Maybe<Scalars['String']>;
};

export type Apex = {
  __typename?: 'Apex';
  gameSlug: Scalars['String'];
  lastSessionStartDate?: Maybe<Scalars['String']>;
  legendUsed?: Maybe<Scalars['String']>;
  map: Scalars['String'];
  matchEndDate?: Maybe<Scalars['String']>;
  matchId: Scalars['String'];
  mode: Scalars['String'];
  platformSlug: Scalars['String'];
  playerArenaRankScoreChange?: Maybe<Scalars['String']>;
  playerDamage?: Maybe<Scalars['String']>;
  playerHeadshots?: Maybe<Scalars['String']>;
  playerKills?: Maybe<Scalars['String']>;
  playerLevel?: Maybe<Scalars['String']>;
  playerRankScoreChange?: Maybe<Scalars['String']>;
  playerTimesPlacedTopThree?: Maybe<Scalars['String']>;
  userIdentifier: Scalars['String'];
};

/** Represents base is_admin response */
export type AuthIsAdminResult = {
  __typename?: 'AuthIsAdminResult';
  isAdmin?: Maybe<Scalars['Boolean']>;
  verificationCode?: Maybe<Scalars['String']>;
};

export type AuthenticateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type AuthenticationMutationOutput = Node & {
  __typename?: 'AuthenticationMutationOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID'];
  result?: Maybe<AuthenticationResult>;
};

/** Represents a cod authentication result. */
export type AuthenticationResult = Node & {
  __typename?: 'AuthenticationResult';
  /** The ID of an object */
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  token: Scalars['String'];
  user: User;
};

/** Available balance types for players */
export enum BalanceType {
  /** The player's bet credits balance */
  BET_CREDITS = 'BET_CREDITS',
  /** The player's main PL balance */
  PL_BALANCE = 'PL_BALANCE'
}

export enum BetDisplayOptions {
  /** a numeric representation with 2 significant figures i.e. 2.12 */
  DECIMAL_2SF = 'DECIMAL_2SF',
  /** a numeric representation i.e. 1000 */
  NUMBER = 'NUMBER',
  /** an ordinal representation i.e. 1st */
  ORDINAL = 'ORDINAL',
  /** a percentage representation i.e. 35% */
  PERCENTAGE = 'PERCENTAGE',
  /** a text representation i.e. 'win the game' */
  TEXT = 'TEXT'
}

/** Paginated response for bet history */
export type BetHistoryResponse = {
  __typename?: 'BetHistoryResponse';
  /** Array of Bet slips */
  betSlips?: Maybe<Array<Maybe<BetSlip>>>;
  /** Pagination information */
  metaData: PaginationDetails;
};

/** A Bet Item */
export type BetItem = Node & {
  __typename?: 'BetItem';
  /** Achieved Multiplier */
  achievedMultiplier?: Maybe<Scalars['String']>;
  /** Result user achieved in game */
  achievedValue?: Maybe<Scalars['String']>;
  /** Amount wagered for bet */
  betAmount?: Maybe<Scalars['String']>;
  /** Type of bet */
  betType?: Maybe<BetTypeEnum>;
  /** Type of currency user for bet item */
  currencyType?: Maybe<Scalars['String']>;
  /** Events */
  events?: Maybe<Array<Maybe<BetItemEvent>>>;
  /** the player's funding sources for this Item */
  fundingSources?: Maybe<Array<Maybe<Financials>>>;
  /** Additional game information */
  gameData?: Maybe<GameData>;
  /** Game */
  gameSlug?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** Bet Item created at */
  insertedAt?: Maybe<Scalars['String']>;
  /** Bet Item level taken */
  level?: Maybe<Scalars['Int']>;
  /** Value needed to win item */
  linesValue?: Maybe<Scalars['String']>;
  /** Id of match that item was resolved with */
  matchId?: Maybe<Scalars['String']>;
  /** Typed Matches */
  matchStats?: Maybe<Array<Maybe<GameUnion>>>;
  /** Matches */
  matches?: Maybe<Scalars['Json']>;
  /** metadata containing things such as parlay information */
  metadata: BetItemMetadata;
  /** Payout value */
  payout?: Maybe<Scalars['String']>;
  /** Payouts List */
  payoutAmounts?: Maybe<Array<Maybe<Financials>>>;
  /** Payout Multiplier */
  payoutMultiplier?: Maybe<Scalars['String']>;
  /** Percentage of bet */
  percentageOfBet?: Maybe<Scalars['String']>;
  /** Currency type used for refund */
  refundCurrencyType?: Maybe<Scalars['String']>;
  /** Reason why the item has been refunded */
  refundReason?: Maybe<Scalars['String']>;
  /** Has the item been refunded */
  refunded?: Maybe<Scalars['Boolean']>;
  /** How is the item being resolved */
  resolutionMethod?: Maybe<Scalars['String']>;
  /** Has the item resolved */
  resolved?: Maybe<Scalars['Boolean']>;
  /** Type of bet that was placed */
  type?: Maybe<Scalars['String']>;
  /** Last updated at */
  updatedAt?: Maybe<Scalars['String']>;
  /** Did the user win this bet item */
  won?: Maybe<Scalars['Boolean']>;
};

/** Adjustments that have occurred to a bet item */
export type BetItemAdjustment = {
  __typename?: 'BetItemAdjustment';
  adjustedBy: Scalars['String'];
  adjustmentReason: Scalars['String'];
  betItemId: Scalars['ID'];
  betSlipAdjustmentId: Scalars['ID'];
  id: Scalars['ID'];
  insertedAt: Scalars['String'];
  newAchievedValue: Scalars['String'];
  newPayouts: Array<Financials>;
  newWon: Scalars['Boolean'];
  oldAchievedValue: Scalars['String'];
  oldPayouts: Array<Financials>;
  oldWon: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};

/** Bounty Range */
export type BetItemBountyRange = {
  __typename?: 'BetItemBountyRange';
  linesValue: Scalars['String'];
  type: Scalars['String'];
};

/** Events */
export type BetItemEvent = {
  __typename?: 'BetItemEvent';
  event?: Maybe<Scalars['String']>;
  insertedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Bet_item_metadata */
export type BetItemMetadata = {
  __typename?: 'BetItemMetadata';
  multiGameParlay?: Maybe<MultiGameParlay>;
  singleGameBounty?: Maybe<Bounty>;
  singleGameParlay?: Maybe<Parlay>;
  specialRules?: Maybe<Array<Maybe<SpecialRules>>>;
  specialRulesApplied?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Ranges */
export type BetItemRange = {
  __typename?: 'BetItemRange';
  /** Increments that a user must achieve to get a payout. I.e every 2 kills, 500 damage */
  bountyIncrement: Scalars['String'];
  /** min and max range values */
  bountyRange: Array<Maybe<BetItemBountyRange>>;
  /** How many times can get paid for this range. */
  bountyTimesAchievable: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier?: Maybe<Scalars['String']>;
};

/** Represents a selection of related bets */
export type BetLineItem = {
  __typename?: 'BetLineItem';
  betType: BetType;
  category: Scalars['String'];
  cost: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  lineType: BetLineType;
  multiGameTeamParlayOptions: Array<MultiGameTeamParlayOption>;
  options: Array<Option>;
  required: Scalars['Boolean'];
  singleGameBountyOptions: Array<SingleGameTeamBountyOption>;
  singleGameOptions: Array<BetOption>;
  singleGameTeamParlayOptions: Array<ParlayBetOption>;
  title: Scalars['String'];
};

export enum BetLineType {
  /** The assists bet line */
  ASSISTS = 'ASSISTS',
  /** The average kills per round bet line */
  AVERAGE_KILLS_PER_ROUND = 'AVERAGE_KILLS_PER_ROUND',
  /** The best on team line */
  BEST_ON_TEAM = 'BEST_ON_TEAM',
  /** Win game without losing crown */
  CLASH_FLAWLESS_VICTORY = 'CLASH_FLAWLESS_VICTORY',
  /** Win game by winning three crowns */
  CLASH_MATCH_THREE_CROWNS = 'CLASH_MATCH_THREE_CROWNS',
  /** Win three games without losing a crown adn by winning three crowns */
  CLASH_TOTAL_VICTORY = 'CLASH_TOTAL_VICTORY',
  /** Gulag win line */
  COMPLETED_CONTRACTS = 'COMPLETED_CONTRACTS',
  /** The damage bet line */
  DAMAGE = 'DAMAGE',
  /** The player death */
  DEATH = 'DEATH',
  /** The five kills per round bet line */
  FIVE_KILLS_PER_ROUND = 'FIVE_KILLS_PER_ROUND',
  /** Win game without dying */
  FLAWLESS_VICTORY = 'FLAWLESS_VICTORY',
  /** The four kills per round bet line */
  FOUR_KILLS_PER_ROUND = 'FOUR_KILLS_PER_ROUND',
  /** The goals be line */
  GOALS = 'GOALS',
  /** Gulag win line */
  GULAG_WIN = 'GULAG_WIN',
  /** The kills bet line */
  KILLS = 'KILLS',
  /** The last kill bet line */
  LAST_KILL = 'LAST_KILL',
  /** The main bet line */
  MAIN = 'MAIN',
  /** The match bet line */
  MATCH = 'MATCH',
  /** Match win line */
  MATCH_WIN = 'MATCH_WIN',
  /** Multi-game parlay line */
  MULTI_PARLAY = 'MULTI_PARLAY',
  /** The player MVP line */
  MVP = 'MVP',
  /** Parlay line */
  PARLAY = 'PARLAY',
  /** The placement bet line */
  PLACEMENT = 'PLACEMENT',
  /** The player grade bet line */
  PLAYER_GRADE = 'PLAYER_GRADE',
  /** The play of the game line */
  PLAY_OF_THE_GAME = 'PLAY_OF_THE_GAME',
  /** The podium placement line */
  PODIUM_PLACEMENT = 'PODIUM_PLACEMENT',
  /** The rebounds bet line */
  REBOUNDS = 'REBOUNDS',
  /** Win match by X points */
  SPREAD = 'SPREAD',
  /** The three kills per round bet line */
  THREE_KILLS_PER_ROUND = 'THREE_KILLS_PER_ROUND',
  /** Top 10 line */
  TOP_TEN = 'TOP_TEN',
  /** The top three bet line */
  TOP_THREE = 'TOP_THREE',
  /** Top 25 line */
  TOP_TWENTY_FIVE = 'TOP_TWENTY_FIVE',
  /** The two kills per round bet line */
  TWO_KILLS_PER_ROUND = 'TWO_KILLS_PER_ROUND'
}

/** A single option for a bet */
export type BetOption = {
  __typename?: 'BetOption';
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Bet level */
  level: Scalars['String'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String'];
  /** If the bet should be selected */
  selected: Scalars['Boolean'];
  /** The title of the bet option */
  title: Scalars['String'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
  /** The amount won on the bet */
  win: Scalars['String'];
};

export type BetRestriction = {
  __typename?: 'BetRestriction';
  lockState: LockState;
  valueId: Scalars['String'];
};

/** A Bet Slip */
export type BetSlip = Node & {
  __typename?: 'BetSlip';
  /** Bet items/lines */
  betItems: Array<Maybe<BetItem>>;
  /** Adjustments that have been made to this bet slip */
  betSlipAdjustments?: Maybe<Array<BetSlipAdjustment>>;
  /** Total amount wagered */
  betTotalAmount?: Maybe<Scalars['String']>;
  /** Game the bet slip is for */
  gameSlug?: Maybe<Scalars['String']>;
  /** Correlation ID for the bet */
  groupBetId?: Maybe<Scalars['ID']>;
  /** Does this bet slip contain a mystery bet */
  hasMysteryItem?: Maybe<Scalars['Boolean']>;
  /** The ID of an object */
  id: Scalars['ID'];
  /** When was the bet created */
  insertedAt?: Maybe<Scalars['String']>;
  /** Total the user won from bet slip */
  payout?: Maybe<Scalars['String']>;
  /** Payouts List */
  payoutAmounts?: Maybe<Array<Maybe<Financials>>>;
  /** Why was this bet slip refunded */
  refundReason?: Maybe<Scalars['String']>;
  /** Bet slip resolved at */
  resolvedAt?: Maybe<Scalars['String']>;
  /** Service fee */
  serviceFee: Scalars['String'];
  /** Staking offer for slip */
  stakeOffer?: Maybe<StakeOffer>;
  /** Status of the bet slip */
  status?: Maybe<Scalars['String']>;
  /** Does this bet slip contain a sweepstake ticket */
  sweepstakeTicket?: Maybe<Scalars['String']>;
  /** The team the bet was placed as part of */
  team?: Maybe<Team>;
  /** Bet slip last updated at */
  updatedAt?: Maybe<Scalars['String']>;
  /** Bet slip owner */
  user: User;
  /** Bet Form By betslip game */
  userGameStatistics?: Maybe<UserGameStatistics>;
};

/** Adjustments that have occurred to a bet slip */
export type BetSlipAdjustment = {
  __typename?: 'BetSlipAdjustment';
  adjustedBy: Scalars['String'];
  adjustmentReason: Scalars['String'];
  betItemAdjustments: Array<BetItemAdjustment>;
  betSlipId: Scalars['ID'];
  id: Scalars['ID'];
  insertedAt: Scalars['String'];
  metadata?: Maybe<BetSlipAdjustmentMetadata>;
  newPayout: Scalars['String'];
  newPayouts: Array<Financials>;
  newStatus: Scalars['String'];
  oldPayout: Scalars['String'];
  oldPayouts: Array<Financials>;
  oldStatus: Scalars['String'];
  updatedAt: Scalars['String'];
};

/** Additional metadata for bet slip adjustments */
export type BetSlipAdjustmentMetadata = {
  __typename?: 'BetSlipAdjustmentMetadata';
  outstandingAmounts: Array<Financials>;
};

export enum BetSlipForm {
  /** Net loss on bet slip */
  L = 'L',
  /** Bet slip voided by admin */
  V = 'V',
  /** Net win on bet slip */
  W = 'W'
}

export enum BetType {
  /** a bet covering multiple games */
  MULTI_GAME = 'MULTI_GAME',
  /** a parlay bet covering multiple games */
  MULTI_GAME_TEAM_PARLAY = 'MULTI_GAME_TEAM_PARLAY',
  /** a bet covering a single game */
  SINGLE_GAME = 'SINGLE_GAME',
  /** a bet where a user can win in a range of payouts */
  SINGLE_GAME_BOUNTY = 'SINGLE_GAME_BOUNTY',
  /** a bet covering a single game, where multiple options can be chosen */
  SINGLE_GAME_TEAM_MULTI_OPTION = 'SINGLE_GAME_TEAM_MULTI_OPTION',
  /** a single game parlay bet */
  SINGLE_GAME_TEAM_PARLAY = 'SINGLE_GAME_TEAM_PARLAY',
  /** a bet covering a single game, where a single option can be chosen */
  SINGLE_GAME_TEAM_SINGLE_OPTION = 'SINGLE_GAME_TEAM_SINGLE_OPTION',
  /** a solo bet */
  SOLO = 'SOLO'
}

export enum BetTypeEnum {
  /** Multi-game Parlay type bets */
  MULTI_GAME_PARLAY = 'MULTI_GAME_PARLAY',
  /** Bounty type bets */
  SINGLE_GAME_BOUNTY = 'SINGLE_GAME_BOUNTY',
  /** Single item type bets */
  SINGLE_GAME_ITEM = 'SINGLE_GAME_ITEM',
  /** Parlay type bets */
  SINGLE_GAME_PARLAY = 'SINGLE_GAME_PARLAY'
}

/** Bounty */
export type Bounty = {
  __typename?: 'Bounty';
  ranges: Array<Maybe<BetItemRange>>;
};

/** Bounty Range */
export type BountyRange = {
  __typename?: 'BountyRange';
  /** Increments that a user must achieve to get a payout. I.e every 2 kills, 500 damage */
  bountyIncrement: Scalars['String'];
  /** min and max range values */
  bountyRange: Array<Maybe<Range>>;
  /** How many times can get paid for this range. */
  bountyTimesAchievable: Scalars['String'];
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String'];
};

export type CancelBetByGroupBetIdInput = {
  groupBetId: Scalars['String'];
};

export type Cfb25 = {
  __typename?: 'Cfb25';
  gameSlug: Scalars['String'];
};

/** A claimed external offer */
export type ClaimedExternalOffer = {
  __typename?: 'ClaimedExternalOffer';
  /** The date when the offer was claimed */
  claimedAt: Scalars['DateTime'];
  /** The offer that was claimed */
  offer: ExternalOffer;
  /** The offer code provided by the partner */
  offerCode: Scalars['String'];
  /** The id of the user who claimed the offer */
  userId: Scalars['ID'];
};

export type ClashRoyale = {
  __typename?: 'ClashRoyale';
  gameSlug: Scalars['String'];
};

export type Codbo6 = {
  __typename?: 'Codbo6';
  gameSlug: Scalars['String'];
};

export type Codmw3 = {
  __typename?: 'Codmw3';
  gameSlug: Scalars['String'];
};

export type Codwz2 = {
  __typename?: 'Codwz2';
  gameSlug: Scalars['String'];
  map?: Maybe<Scalars['String']>;
  matchDuration?: Maybe<Scalars['String']>;
  matchEndDate?: Maybe<Scalars['String']>;
  matchId?: Maybe<Scalars['String']>;
  matchMode?: Maybe<Scalars['String']>;
  matchStartDate?: Maybe<Scalars['String']>;
  matchWin?: Maybe<Scalars['Boolean']>;
  playerGotFinalKill?: Maybe<Scalars['Boolean']>;
  playerGotFlawlessVictory?: Maybe<Scalars['Boolean']>;
  playerKills?: Maybe<Scalars['String']>;
  playerPlacement?: Maybe<Scalars['String']>;
  userIdentifier?: Maybe<Scalars['String']>;
};

export type CreateAccountStepOneInput = {
  dob: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateAccountStepThreeInput = {
  password?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
};

export type CreateGameSpecificTeamInput = {
  associatedGameModes: Array<Scalars['String']>;
  game?: InputMaybe<Scalars['String']>;
  gameData?: InputMaybe<GameDataInput>;
  gameMode?: InputMaybe<Scalars['String']>;
  legacyBetCategory?: InputMaybe<Scalars['String']>;
  maximumAllowedTeamSize?: InputMaybe<Scalars['Int']>;
  modeTeamSize?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Template for onfido id verification */
export enum CreateOnfidoTemplateTrigger {
  /** deposit attempted over cumulative limit */
  CUMULATIVE_DEPOSIT = 'CUMULATIVE_DEPOSIT',
  /** deposit attempted */
  DEPOSIT = 'DEPOSIT',
  /** withdrawal attempted */
  WITHDRAWAL = 'WITHDRAWAL'
}

/** Template for onfido id verification, workflow */
export enum CreateOnfidoTemplateWorkflow {
  /** full idv verification */
  IDV = 'IDV'
}

export type CreateUserInput = {
  battlenetPlatformUsername?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  plCoreUserId?: InputMaybe<Scalars['String']>;
  psnPlatformUsername?: InputMaybe<Scalars['String']>;
  xblPlatformUsername?: InputMaybe<Scalars['String']>;
};

export type DepositProviderResponse = {
  __typename?: 'DepositProviderResponse';
  /** Flag to denote if the provider is currently enabled for the platform */
  enabled: Scalars['Boolean'];
  /** The ID of the provider */
  id: Scalars['ID'];
  /** Maximum transfer type amount for the provider */
  max: Scalars['String'];
  /** Minimum transfer type amount for the provider */
  min: Scalars['String'];
  /** Payment methods available for the provider */
  paymentMethods: Array<PaymentMethod>;
  /** Platform of the provider */
  platform: PlatformEnum;
  /** Provider name */
  provider: ProviderEnum;
  /** Stored payment methods for the user */
  storedPaymentMethods?: Maybe<Array<StoredPaymentMethod>>;
  /** Enum of the type of transfer being made. Currently Withdrawal or Deposit. */
  transferType: Scalars['String'];
};

/** Individual entry for deposit refund information */
export type DepositRefundEntry = {
  __typename?: 'DepositRefundEntry';
  /** The deposit amount in cents */
  depositAmount?: Maybe<Scalars['String']>;
  /** The provider reference for the deposit */
  depositProviderReference?: Maybe<Scalars['String']>;
  /** The ID of the deposit transaction */
  depositTransactionId?: Maybe<Scalars['String']>;
  /** The provider of the deposit */
  provider: ProviderEnum;
  /** The reason for the refund */
  refundReason?: Maybe<Scalars['String']>;
  /** Who refunded this deposit */
  refundedBy?: Maybe<Scalars['String']>;
  /** The related withdrawal payment status ID */
  relatedWithdrawalPaymentStatusId?: Maybe<Scalars['String']>;
  /** The time of the refund */
  timeOfRefund?: Maybe<Scalars['String']>;
  /** The total amount refunded in cents */
  totalAmountRefunded?: Maybe<Scalars['String']>;
};

/** Array of refund information entries related to a deposit */
export type DepositRefundInfoArrayMetadata = {
  __typename?: 'DepositRefundInfoArrayMetadata';
  /** The deposit amount in cents */
  depositAmount: Scalars['String'];
  /** The provider reference for the deposit */
  depositProviderReference?: Maybe<Scalars['String']>;
  /** The deposit transaction ID */
  depositTransactionId: Scalars['String'];
  /** The provider of the deposit */
  provider: ProviderEnum;
  /** A list of refund entries related to this deposit */
  refundEntries?: Maybe<Array<DepositRefundEntry>>;
  /** The total amount refunded in cents */
  totalAmountRefunded: Scalars['String'];
};

/** The information returned for all deposit operations */
export type DepositResponse = {
  __typename?: 'DepositResponse';
  /** The amount (in cents) of the deposit request */
  amount: Scalars['Int'];
  /** Payment creation date time */
  createdAt: Scalars['String'];
  /** The ID of the deposit */
  id: Scalars['ID'];
  /** Metadata related to the payment status */
  metadata?: Maybe<PaymentStatusMetadata>;
  /** The latest status of the deposit request */
  mostRecentStatus: Status;
  /** The platform for this request (currently only 'adyen' is supported) */
  provider: ProviderEnum;
  /** Payment provider details */
  providerDetails: PaymentProviderDetails;
  /** The provider's reference for the deposit */
  providerReference?: Maybe<Scalars['String']>;
  /** Response data from the provider as a string. Must be parsed to JSON before being provided to Adyen FE components */
  providerResponse?: Maybe<Scalars['String']>;
  /** Response data from provider for if the deposit had to be reversed as a string */
  providerReversalResponse?: Maybe<Scalars['String']>;
  /** Payments API user details */
  user?: Maybe<PaymentUserDetails>;
};

export type Eafc25 = {
  __typename?: 'Eafc25';
  gameSlug: Scalars['String'];
};

export type Eafc26 = {
  __typename?: 'Eafc26';
  gameSlug: Scalars['String'];
};

/** Represents errors from a query or mutation */
export type Errors = Node & {
  __typename?: 'Errors';
  fields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The ID of an object */
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

export type ExpediteTierConfig = {
  __typename?: 'ExpediteTierConfig';
  /** Flag to determine if the expedite tier considers free withdrawals logic | NOT IMPLEMENTED */
  allowFreeWithdrawal: Scalars['String'];
  /** Flag to denote if the expedite tier is disabled. This will likely always be true */
  enabled: Scalars['Boolean'];
  /** Expedite tier enum name */
  expediteTier: ExpediteTierEnum;
  /** Fee amount for the tier */
  fee: Scalars['String'];
  /** The ID of the expedite tier item */
  id: Scalars['ID'];
  /** Maximum time period for the withdrawal to be processed in for the tier */
  maxTimePeriod: Scalars['Int'];
  /** Minimum time period for the withdrawal to be processed in for the tier */
  minTimePeriod: Scalars['Int'];
  /** Platform enum name */
  platform: PlatformEnum;
  /** Provider name */
  provider: ProviderEnum;
  /** Public facing name for the expedite tier */
  readableName: Scalars['String'];
};

export enum ExpediteTierEnum {
  /** Faster withdrawal method with higher fees */
  EXPEDITE = 'EXPEDITE',
  /** Slowest withdrawal method, but has no fees */
  FREE = 'FREE',
  /** Slower than standard */
  SLOW = 'SLOW',
  /** Withdrawal method with low fees */
  STANDARD = 'STANDARD'
}

/** An external available offer */
export type ExternalOffer = {
  __typename?: 'ExternalOffer';
  /** The start date of the offer */
  activeFrom: Scalars['DateTime'];
  /** The end date of the offer */
  activeTo?: Maybe<Scalars['DateTime']>;
  /** The unique identifier for the offer */
  id: Scalars['ID'];
  /** The image URL for the offer */
  image?: Maybe<Scalars['String']>;
  /** The large image URL for the offer */
  largeImage?: Maybe<Scalars['String']>;
  /** The name of the offer */
  name: Scalars['String'];
  /** Whether the offer is a code or a url */
  offerType: OfferType;
  /** The partner associated with the offer */
  partner: ExternalPartner;
  /** The unique key to match localization phrases */
  phraseKey: Scalars['String'];
  /** Whether the user has seen this offer */
  seen?: Maybe<Scalars['Boolean']>;
  /** The URL to claim the offer, when the offerType is url and the url is static */
  url?: Maybe<Scalars['String']>;
};

/** External Offers response */
export type ExternalOffersResponse = {
  __typename?: 'ExternalOffersResponse';
  /** List of available external offers */
  availableOffers?: Maybe<Array<Maybe<ExternalOffer>>>;
  /** List of claimed external offers */
  claimedOffers?: Maybe<Array<Maybe<ClaimedExternalOffer>>>;
};

/** Partner information for external offers and adverts */
export type ExternalPartner = {
  __typename?: 'ExternalPartner';
  /** The unique identifier for the partner */
  id: Scalars['ID'];
  /** The name of the partner */
  name: Scalars['String'];
};

/** An external partner ad */
export type ExternalPartnerAd = {
  __typename?: 'ExternalPartnerAd';
  /** The start date of the ad */
  activeFrom: Scalars['DateTime'];
  /** The end date of the ad */
  activeTo?: Maybe<Scalars['DateTime']>;
  /** The image URL for the ad */
  bannerImageUrl: Scalars['String'];
  /** The URL to redirect when the ad is clicked */
  bannerLink: Scalars['String'];
  /** The name of the ad */
  bannerName: Scalars['String'];
  /** Whether the ad is active */
  enabled: Scalars['Boolean'];
  /** The unique identifier for the ad */
  id: Scalars['ID'];
  /** The partner associated with the ad */
  partnerName: Scalars['String'];
  /** The unique key to match localization phrases */
  phraseKey: Scalars['String'];
  /** The subtitle content of the ad */
  subtitle?: Maybe<Scalars['String']>;
  /** The title content of the ad */
  title?: Maybe<Scalars['String']>;
  /** The type of the ad */
  type: Scalars['String'];
};

/** Represents a cod feature flag entity. */
export type Feature = Node & {
  __typename?: 'Feature';
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FilterInput = {
  id?: InputMaybe<IdInput>;
};

export enum FilterStatus {
  /** Incomplete wagers */
  PENDING = 'pending',
  /** Completed wagers, includes won, lost and refunded */
  RESOLVED = 'resolved'
}

/** Represents a wallet for a user. */
export type Financials = {
  __typename?: 'Financials';
  amount: Scalars['Decimal'];
  wallet: BalanceType;
};

export type FinancialsInput = {
  amount: Scalars['Decimal'];
  userId?: InputMaybe<Scalars['String']>;
  wallet: BalanceType;
};

export type Fortnite = {
  __typename?: 'Fortnite';
  gameSlug: Scalars['String'];
};

/** Game Data */
export type GameData = {
  __typename?: 'GameData';
  apexLegend?: Maybe<Scalars['String']>;
  gameMode?: Maybe<Scalars['String']>;
  /** I.e Clan tag, to be used for games that support it/require it for twitch streaming */
  livenessCheck?: Maybe<LivenessCheck>;
  map?: Maybe<Scalars['String']>;
  squadSize?: Maybe<Scalars['Int']>;
};

export type GameDataInput = {
  gameMap?: InputMaybe<Scalars['String']>;
  gameMode?: InputMaybe<Scalars['String']>;
};

export type GameHistoryOutput = {
  __typename?: 'GameHistoryOutput';
  gameHistory?: Maybe<Array<Maybe<GameUnion>>>;
};

export type GameModeBetRestriction = {
  __typename?: 'GameModeBetRestriction';
  betRestrictions: Array<BetRestriction>;
  gameMode: Scalars['String'];
};

export type GamePlatformStatus = {
  __typename?: 'GamePlatformStatus';
  game: Games;
  metadata: GamePlatformStatusMetadata;
  platform: Platforms;
  status: PlatformBettingStatus;
  /** Which game identifier does this betting status belong to. This can be either the token or the gamer tag */
  userIdentifier?: Maybe<Scalars['String']>;
};

/** Metadata for a game platform */
export type GamePlatformStatusMetadata = {
  __typename?: 'GamePlatformStatusMetadata';
  betsPlaced?: Maybe<Scalars['Int']>;
  betsPlacedMmb?: Maybe<Scalars['Int']>;
  betsRefunded?: Maybe<Scalars['Int']>;
  betsRefundedMmb?: Maybe<Scalars['Int']>;
  betsSettled?: Maybe<Scalars['Int']>;
  betsSettledMmb?: Maybe<Scalars['Int']>;
  bettingFairPlayTermsAccepted?: Maybe<Scalars['Boolean']>;
  character?: Maybe<Scalars['String']>;
  damageBanner?: Maybe<Scalars['Boolean']>;
  fetchFailReason?: Maybe<Scalars['String']>;
  gamertagUpdatedCount?: Maybe<Scalars['Int']>;
  initialFetchState?: Maybe<Scalars['String']>;
  killsBanner?: Maybe<Scalars['Boolean']>;
  lastUpdatedAt?: Maybe<Scalars['String']>;
  lastUserFetch?: Maybe<Scalars['String']>;
  retryAttempts?: Maybe<Scalars['Int']>;
  settledBetCounts?: Maybe<Array<Maybe<SettledBetCounts>>>;
  settledBetDenominationCounts?: Maybe<SettledBetDenominationCounts>;
  storedMatchCount?: Maybe<Scalars['String']>;
  topThreeBanner?: Maybe<Scalars['Boolean']>;
  totalMatchesBanner?: Maybe<Scalars['Boolean']>;
  twitchAudioMuted?: Maybe<Scalars['Boolean']>;
  twitchRequired?: Maybe<Scalars['Boolean']>;
  twitchVodEnabled?: Maybe<Scalars['Boolean']>;
};

export type GameUnion = Apex | Cfb25 | ClashRoyale | Codbo6 | Codmw3 | Codwz2 | Eafc25 | Eafc26 | Fortnite | Madden25 | Madden26 | MarvelRivals | Nba2k25 | Nba2k26 | RocketLeague | Valorant;

export enum Games {
  /** APEX */
  APEX = 'apex',
  /** COLLEGE FOOTBALL 25 */
  CFB25 = 'cfb25',
  /** COLLEGE FOOTBALL 26 */
  CFB26 = 'cfb26',
  /** Clash Royale */
  CLASH_ROYALE = 'clash_royale',
  /** COD BLACK OPS 6 */
  CODBO6 = 'codbo6',
  /** COD MODERN WARFARE 2 */
  CODMW2 = 'codmw2',
  /** COD MODERN WARFARE 3 */
  CODMW3 = 'codmw3',
  /** COD WARZONE */
  CODWZ = 'codwz',
  /** COD WARZONE 2 */
  CODWZ2 = 'codwz2',
  /** CSGO */
  CSGO = 'csgo',
  /** CSGO2 */
  CSGO2 = 'csgo2',
  /** EAFC 25 */
  EAFC25 = 'eafc25',
  /** EAFC 26 */
  EAFC26 = 'eafc26',
  /** FORTNITE */
  FORTNITE = 'fortnite',
  /** HALO */
  HALO = 'halo',
  /** LEAGUE_OF_LEGENDS */
  LEAGUE_OF_LEGENDS = 'league_of_legends',
  /** MADDEN 25 */
  MADDEN25 = 'madden25',
  /** MADDEN 26 */
  MADDEN26 = 'madden26',
  /** MARVEL RIVALS */
  MARVEL_RIVALS = 'marvel_rivals',
  /** NBA 2K25 */
  NBA2K25 = 'nba2k25',
  /** NBA 2K26 */
  NBA2K26 = 'nba2k26',
  /** ROCKET LEAGUE */
  ROCKET_LEAGUE = 'rocket_league',
  /** VALORANT */
  VALORANT = 'valorant'
}

export type GenericUserMutationOutput = Node & {
  __typename?: 'GenericUserMutationOutput';
  /** The ID of an object */
  id: Scalars['ID'];
  user: User;
};

export type GetFeatureFlagInput = {
  domain?: InputMaybe<Scalars['String']>;
};

export type IdInput = {
  eq?: InputMaybe<Scalars['String']>;
};

export type InsertSpecialRuleUserInput = {
  rules?: InputMaybe<Array<InputMaybe<SpecialRuleUserInput>>>;
};

/** Represents a cod line entity. */
export type Line = Node & {
  __typename?: 'Line';
  goal: Scalars['Int'];
  /** The ID of an object */
  id: Scalars['ID'];
  level: Scalars['Int'];
  payout: Scalars['Decimal'];
};

export type ListUsersOutput = Node & {
  __typename?: 'ListUsersOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID'];
  results?: Maybe<User>;
};

/** liveness check */
export type LivenessCheck = {
  __typename?: 'LivenessCheck';
  colour?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
};

export enum LockState {
  /** Bet Denomination follows default unlock restrictions for this user */
  DEFAULT = 'DEFAULT',
  /** Bet Denomination is locked to the user */
  LOCKED = 'LOCKED',
  /** Bet Denomination is unlocked to the user, without any restrictions */
  UNLOCKED = 'UNLOCKED'
}

/** User locked status */
export type LockedStatus = {
  __typename?: 'LockedStatus';
  reason: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type Madden25 = {
  __typename?: 'Madden25';
  gameSlug: Scalars['String'];
};

export type Madden26 = {
  __typename?: 'Madden26';
  gameSlug: Scalars['String'];
};

export type MarvelRivals = {
  __typename?: 'MarvelRivals';
  gameSlug: Scalars['String'];
};

export type MatchDataResponse = {
  __typename?: 'MatchDataResponse';
  scheduledFetch?: Maybe<Scalars['Boolean']>;
};

/** Multi-Game Parlay */
export type MultiGameParlay = {
  __typename?: 'MultiGameParlay';
  failuresAllowed: Scalars['Int'];
  legs: Array<MultiGameParlayLeg>;
  payouts: Array<MultiGameTeamPayout>;
  requirements: Array<ParlayBetItem>;
  successesRequired: Scalars['Int'];
};

/** Multi-Game Parlay Leg (e.g. match, round) */
export type MultiGameParlayLeg = {
  __typename?: 'MultiGameParlayLeg';
  achievedValue: Array<AchievedValue>;
  id: Scalars['ID'];
  insertedAt: Scalars['String'];
  matchId?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  status: MultiGameParlayStatusEnum;
  updatedAt: Scalars['String'];
};

export enum MultiGameParlayStatusEnum {
  /** Multi-game parlay has been won or lost already; this leg is no longer relevant */
  CANCELLED = 'cancelled',
  /** Leg has been lost */
  LOST = 'lost',
  /** Leg has not been played yet */
  PENDING = 'pending',
  /** Leg has been won */
  WON = 'won'
}

/** A multi-game parlay bet option */
export type MultiGameTeamParlayOption = {
  __typename?: 'MultiGameTeamParlayOption';
  /** The number of failures allowed before the bet is lost */
  failuresAllowed: Scalars['Int'];
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Bet level */
  level: Scalars['String'];
  /** Payouts */
  payouts: Array<MultiGameTeamPayout>;
  /** Parlay requirements */
  requirements: Array<ParlayBetItem>;
  /** If the bet should be selected */
  selected: Scalars['Boolean'];
  /** The number of successes required before the bet is won */
  successesRequired: Scalars['Int'];
};

/** A single payout option for multi-game parlays */
export type MultiGameTeamPayout = {
  __typename?: 'MultiGameTeamPayout';
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String'];
  /** The conditions in which this payout option will be selected */
  requirements: Array<MultiGameTeamPayoutRequirements>;
  /** The amount won on the bet */
  win: Scalars['String'];
};

/** A single requirement for a multi-game payout */
export type MultiGameTeamPayoutRequirements = {
  __typename?: 'MultiGameTeamPayoutRequirements';
  goal: Scalars['Int'];
  requirement: Scalars['String'];
};

export type Nba2k25 = {
  __typename?: 'Nba2k25';
  gameSlug: Scalars['String'];
};

export type Nba2k26 = {
  __typename?: 'Nba2k26';
  gameSlug: Scalars['String'];
};

export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type Note = Node & {
  __typename?: 'Note';
  authorEmail: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt: Scalars['DateTime'];
  text: Scalars['String'];
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  edges?: Maybe<Array<Maybe<NoteEdge>>>;
  pageInfo: PageInfo;
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Note>;
};

export enum OfferType {
  /** The offer is a code */
  CODE = 'CODE',
  /** The offer is a URL */
  URL = 'URL'
}

export type OnfidoCreateTokenInput = {
  trigger?: InputMaybe<CreateOnfidoTemplateTrigger>;
  workflow?: InputMaybe<CreateOnfidoTemplateWorkflow>;
};

export type OnfidoMutationOutput = Node & {
  __typename?: 'OnfidoMutationOutput';
  /** The ID of an object */
  id: Scalars['ID'];
  token: Scalars['String'];
  workflowRunId: Scalars['String'];
};

export enum OnfidoVerificationStatus {
  /** User has completed verification and verification is approved */
  APPROVED = 'APPROVED',
  /** User has not started verification */
  INACTIVE = 'INACTIVE',
  /** User has started verification and verification is pending */
  PENDING = 'PENDING',
  /** User's verification was rejected */
  REJECTED = 'REJECTED',
  /** User has started verification and needs manual review */
  REVIEW = 'REVIEW'
}

/** Represents a selection of related bets */
export type Option = MultiGameTeamParlayOption | SingleGameTeamBountyOption | SingleGameTeamOption | SingleGameTeamParlayOption;

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The standard body for pagination metadata */
export type PaginationDetails = {
  __typename?: 'PaginationDetails';
  /** Whether or not you can go forwards a page */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** Whether or not you can go backwards a page */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** The total amount of items that can be taken */
  itemCount?: Maybe<Scalars['Int']>;
  /** The current page */
  page?: Maybe<Scalars['Int']>;
  /** The total number of pages that can be fetched with the current take value */
  pageCount?: Maybe<Scalars['Int']>;
  /** How many items the query took */
  take?: Maybe<Scalars['Int']>;
};

/** Parlay */
export type Parlay = {
  __typename?: 'Parlay';
  id: Scalars['ID'];
  legTypesTaken: Array<Maybe<Scalars['String']>>;
  legTypesTakenUnique: Array<Maybe<Scalars['String']>>;
  numberOfLegs: Scalars['Int'];
  numberOfLegsLost?: Maybe<Scalars['Int']>;
  numberOfLegsWon?: Maybe<Scalars['Int']>;
  won?: Maybe<Scalars['Boolean']>;
};

/** A single requirement for a parlay */
export type ParlayBetItem = {
  __typename?: 'ParlayBetItem';
  /** Type of line i.e Kills */
  lineType: Scalars['String'];
  /** The title of the bet option */
  title: Scalars['String'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
};

/** A parlay bet option */
export type ParlayBetOption = {
  __typename?: 'ParlayBetOption';
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Bet level */
  level: Scalars['String'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String'];
  /** Parlay requirements */
  requirements: Array<ParlayBetItem>;
  /** If the bet should be selected */
  selected: Scalars['Boolean'];
  /** The amount won on the bet */
  win: Scalars['String'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** A list of apps for this payment method */
  apps?: Maybe<Array<AdyenApp>>;
  /** Brand for the selected gift card. For example: plaxtix, hmclub */
  brand?: Maybe<Scalars['String']>;
  /** List of possible brands. For example: visa, mc */
  brands?: Maybe<Array<Scalars['String']>>;
  /** The configuration of the payment method */
  configuration?: Maybe<AdyenPaymentMethodConfiguration>;
  /** The funding source of the payment method */
  fundingSource?: Maybe<Scalars['String']>;
  /** The group where this payment method belongs to */
  group?: Maybe<AdyenGroup>;
  /** A list of issuers for this payment method */
  issuers?: Maybe<Array<AdyenIssuer>>;
  /** The displayable name of this payment method */
  name: Scalars['String'];
  /** The unique payment method code */
  type: Scalars['String'];
};

/** The provider details stored against the payment */
export type PaymentProviderDetails = AdyenProviderDetails | PaypalProviderDetails;

/** Metadata related to the payment status */
export type PaymentStatusMetadata = {
  __typename?: 'PaymentStatusMetadata';
  /** The deposit refund information related to this payment status */
  depositRefundInfo?: Maybe<DepositRefundInfoArrayMetadata>;
  /** The withdrawal amendment information related to this payment status */
  withdrawalAmendmentInfo?: Maybe<WithdrawalAmendmentInfoMetadata>;
};

/** Payments API user details */
export type PaymentUserDetails = {
  __typename?: 'PaymentUserDetails';
  communicationEmail?: Maybe<Scalars['String']>;
  lastFreeWithdrawalDate?: Maybe<Scalars['String']>;
  maxDailyDeposit?: Maybe<Scalars['String']>;
  maxDailyWithdrawal?: Maybe<Scalars['String']>;
  maxWeeklyDeposit?: Maybe<Scalars['String']>;
  maxWeeklyWithdrawal?: Maybe<Scalars['String']>;
  platform?: Maybe<PlatformEnum>;
};

/** Represents a payout */
export type Payout = Node & {
  __typename?: 'Payout';
  amount?: Maybe<Scalars['String']>;
  currency?: Maybe<BalanceType>;
  /** The ID of an object */
  id: Scalars['ID'];
  triggerAction?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type PayoutUserPtrOutput = Node & {
  __typename?: 'PayoutUserPtrOutput';
  /** The ID of an object */
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type PaypalDetails = {
  paypalEmail: Scalars['String'];
};

export type PaypalProviderDetails = {
  __typename?: 'PaypalProviderDetails';
  paypalEmail?: Maybe<Scalars['String']>;
};

export type PaypalTransactionProcessInput = {
  authorizationId?: InputMaybe<Scalars['String']>;
  depositFeeAmount?: InputMaybe<Scalars['Int']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type PlaceOmniBalanceBetInput = {
  betValue: Scalars['String'];
  selectedBets: Array<InputMaybe<UserOmniBalanceBetLevelResultInput>>;
};

/** Platform specific betting status */
export enum PlatformBettingStatus {
  /** Attempting to fetch match data for the user */
  PLATFORM_FETCHING_FIRST_MATCHES = 'PLATFORM_FETCHING_FIRST_MATCHES',
  /** Failed the initial fetch for match data on this platform */
  PLATFORM_FETCHING_FIRST_MATCHES_ERROR = 'PLATFORM_FETCHING_FIRST_MATCHES_ERROR',
  /** The user has attempted to relink with a different account */
  PLATFORM_ID_ALTERNATIVE_ACCOUNT = 'PLATFORM_ID_ALTERNATIVE_ACCOUNT',
  /** No ID is avaliable for the platform */
  PLATFORM_ID_NOT_ADDED = 'PLATFORM_ID_NOT_ADDED',
  /** Attempting to fetch platform data with an ID */
  PLATFORM_ID_TOKEN_FETCHING = 'PLATFORM_ID_TOKEN_FETCHING',
  /** Failed to fetch token data for ID */
  PLATFORM_ID_TOKEN_FETCH_FAILED = 'PLATFORM_ID_TOKEN_FETCH_FAILED',
  /** A duplicate token already exists in the database */
  PLATFORM_ID_TOKEN_IN_USE = 'PLATFORM_ID_TOKEN_IN_USE',
  /** The users token has been fetched */
  PLATFORM_ID_TOKEN_KNOWN = 'PLATFORM_ID_TOKEN_KNOWN',
  /** An issue with fetching the users token requires user intervention */
  PLATFORM_ID_TOKEN_USER_ISSUE = 'PLATFORM_ID_TOKEN_USER_ISSUE',
  /** Game platform is missing required metadata */
  PLATFORM_INVALID_CONFIGURATION = 'PLATFORM_INVALID_CONFIGURATION',
  /** Data is not available for this user on the platform */
  PLATFORM_MATCHES_NOT_AVAILABLE = 'PLATFORM_MATCHES_NOT_AVAILABLE',
  /** We have lost the ability to fetch matches for this user */
  PLATFORM_MATCHES_NO_LONGER_AVAILABLE = 'PLATFORM_MATCHES_NO_LONGER_AVAILABLE',
  /** User is ready to bet */
  PLATFORM_READY = 'PLATFORM_READY'
}

export enum PlatformEnum {
  /** Players' Lounge Connect */
  PLC = 'PLC'
}

/** User Platform Identifiers */
export type PlatformIdentifier = {
  __typename?: 'PlatformIdentifier';
  gamerTag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  insertedAt?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<PlatformIdentifierMetadata>;
  platform?: Maybe<Platforms>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** User Platform Identifier Metadata */
export type PlatformIdentifierMetadata = {
  __typename?: 'PlatformIdentifierMetadata';
  id?: Maybe<Scalars['String']>;
  relatedFramedropUuid?: Maybe<Scalars['String']>;
  streamBitrate?: Maybe<Scalars['String']>;
  streamHeight?: Maybe<Scalars['Int']>;
  streamQuality?: Maybe<Scalars['String']>;
  streamQualityUpdatedAt?: Maybe<Scalars['DateTime']>;
  twitchOnboardingComplete?: Maybe<Scalars['Boolean']>;
  twitchProfile?: Maybe<TwitchProfileInfo>;
  twitchStreamInfo?: Maybe<StreamInfo>;
  twitchStreamLink?: Maybe<Scalars['String']>;
  twitchStreamLiveStatus?: Maybe<Scalars['Boolean']>;
  twitchVodEnabled?: Maybe<Scalars['Boolean']>;
  twitchVodLastUpdated?: Maybe<Scalars['DateTime']>;
  twitchVodLatestTimestamp?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum Platforms {
  ACTIVISION = 'ACTIVISION',
  BATTLENET = 'BATTLENET',
  EA = 'EA',
  EPIC_GAMES = 'EPIC_GAMES',
  LEAGUE_OF_LEGENDS = 'LEAGUE_OF_LEGENDS',
  NETEASE_GAMES = 'NETEASE_GAMES',
  ORIGIN = 'ORIGIN',
  PLAYERS_LOUNGE = 'PLAYERS_LOUNGE',
  PLAYSTATION_NETWORK = 'PLAYSTATION_NETWORK',
  RIOT = 'RIOT',
  STEAM = 'STEAM',
  SUPERCELL = 'SUPERCELL',
  TWITCH = 'TWITCH',
  TWOK = 'TWOK',
  WB_GAMES = 'WB_GAMES',
  XBOX_LIVE = 'XBOX_LIVE'
}

/** Represents a cod probabilities entity. */
export type Probabilities = Node & {
  __typename?: 'Probabilities';
  betCategory: Scalars['String'];
  gameMode: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
};

/** Stake offer Product Type union */
export type Product = BetSlip;

export type ProviderConfigResponse = {
  __typename?: 'ProviderConfigResponse';
  /** Flag to denote if the provider is currently enabled for the platform */
  enabled: Scalars['Boolean'];
  /** List of expedite tiers for the provider */
  expediteTiersConfigs: Array<Maybe<ExpediteTierConfig>>;
  /** The ID of the provider */
  id: Scalars['ID'];
  /** Maximum transfer type amount for the provider */
  max: Scalars['String'];
  /** Minimum transfer type amount for the provider */
  min: Scalars['String'];
  /** Platform of the provider */
  platform: PlatformEnum;
  /** Provider name */
  provider: ProviderEnum;
  /** Enum of the type of transfer being made. Currently Withdrawal or Deposit. */
  transferType: Scalars['String'];
};

export type ProviderDetailsInput = {
  adyen?: InputMaybe<AdyenDetails>;
  paypal?: InputMaybe<PaypalDetails>;
};

export enum ProviderEnum {
  /** Adyen */
  ADYEN = 'ADYEN',
  /** PayPal */
  PAYPAL = 'PAYPAL'
}

/** Represents a play through requirement */
export type Ptr = Node & {
  __typename?: 'Ptr';
  claimed?: Maybe<Scalars['Boolean']>;
  claimedAt?: Maybe<Scalars['DateTime']>;
  completed?: Maybe<Scalars['Boolean']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  cumulativeResolvedBetStakeAmount?: Maybe<Array<Maybe<Financials>>>;
  cumulativeResolvedBetStakeTarget?: Maybe<Array<Maybe<Financials>>>;
  depositAmount?: Maybe<Scalars['Float']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  payouts?: Maybe<Array<Maybe<Financials>>>;
  ptrSpecAtCreation?: Maybe<PtrConfig>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

/** Represents a play through requirement config */
export type PtrConfig = Node & {
  __typename?: 'PtrConfig';
  activeForCreation?: Maybe<Scalars['Boolean']>;
  amountSpentAsAPercentageOfDeposit?: Maybe<Scalars['Float']>;
  depositCount?: Maybe<Scalars['Int']>;
  /** The ID of an object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  payoutAsAPercentageOfDeposit?: Maybe<Scalars['Float']>;
};

export type PtrPayoutInput = {
  ptrName?: InputMaybe<Scalars['String']>;
};

export type Range = {
  __typename?: 'Range';
  /** The title of the bet option */
  title: Scalars['String'];
  /** The title of the bet option */
  type: Scalars['String'];
};

/** Represents a referral code. */
export type ReferralCode = Node & {
  __typename?: 'ReferralCode';
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type RocketLeague = {
  __typename?: 'RocketLeague';
  gameSlug: Scalars['String'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Lock or unlock a user */
  adminSetUserLock?: Maybe<GenericUserMutationOutput>;
  /** Set user under review or remove review */
  adminSetUserUnderReview?: Maybe<GenericUserMutationOutput>;
  /** Set bypass for minimum games required for bet to be stakeable */
  adminToggleMinimumGameRequirementForStakableGame?: Maybe<Scalars['Boolean']>;
  /** Set users twitch audio acknowledgement */
  adminUpdateTwitchMute?: Maybe<Scalars['Boolean']>;
  /** Admin Update a User's Password */
  adminUpdateUserPassword?: Maybe<UserMutationOutput>;
  /** Authenticate a User. */
  authenticateUser?: Maybe<AuthenticationMutationOutput>;
  /** Cancel a bet by group bet id. */
  cancelBetByGroupBetId?: Maybe<Array<Maybe<BetSlip>>>;
  /** Cancel a withdrawal */
  cancelWithdrawal?: Maybe<WithdrawalResponse>;
  /** Check VOD status */
  checkTwitchVodStatus?: Maybe<UserMutationOutput>;
  /** Claim an external offer */
  claimExternalOffer?: Maybe<ClaimedExternalOffer>;
  /** Create a User. */
  createAccountStepOne?: Maybe<UserMutationOutput>;
  createAccountStepThree?: Maybe<UserMutationOutput>;
  /** Create a game specific Team. */
  createGameSpecificTeam?: Maybe<TeamMutationOutput>;
  /** Create note for user */
  createNoteForUser?: Maybe<Note>;
  createOnfidoToken?: Maybe<OnfidoMutationOutput>;
  /** Create a users platform and game identifier */
  createPlatformAndGameIdentifier?: Maybe<UserMutationOutput>;
  /** Create a users platform and game identifier async */
  createPlatformAndGameIdentifierAsync?: Maybe<UserMutationOutput>;
  /** Create a stake order */
  createStakeOrder?: Maybe<StakeOrder>;
  /** Create a new User. */
  createUser?: Maybe<UserMutationOutput>;
  /** Add email to user */
  createUserEmail?: Maybe<UserMutationOutput>;
  /** Delete user twitch event subscription */
  deleteTwitchEventSubscription?: Maybe<TwitchSubscriptionDeletionResponse>;
  /** Delete all twitch subscriptions for a user and unlink identifier */
  deleteTwitchEventSubscriptionsByUser?: Maybe<Array<Maybe<TwitchUserSubscriptionDeletionResponse>>>;
  /** Delete all twitch subscriptions for a list of users and unlink identifier */
  deleteTwitchEventSubscriptionsByUserIds?: Maybe<Array<Maybe<TwitchUserSubscriptionDeletionResponse>>>;
  disableUserTeams?: Maybe<UserMutationOutput>;
  /**
   * Attempt to fetch match data for a user
   * @deprecated Deprecated as codwz is no longer available
   */
  fetchUserMatchData?: Maybe<MatchDataResponse>;
  /** Send an access code to a users email for forgotten password */
  forgotPassword?: Maybe<Scalars['Boolean']>;
  /** verify forgotten password code */
  forgotPasswordVerification?: Maybe<AuthenticationResult>;
  /** Mutations that are related to Special Rule Users. */
  insertSpecialRuleUser?: Maybe<SpecialRuleUserMutationOutput>;
  /**
   * Create a users platform and game identifier for a riot game
   * @deprecated No longer supported
   */
  linkRiotCredentials?: Maybe<Scalars['Boolean']>;
  /** Create a users platform identifier for Steam */
  linkSteamCredentials?: Maybe<Scalars['String']>;
  /** Create a users platform identifier for a twitch */
  linkTwitchCredentials?: Maybe<Scalars['Boolean']>;
  /** Payout a users play through requirement. */
  payoutUserPtr?: Maybe<PayoutUserPtrOutput>;
  paypalTransactionProcess?: Maybe<UserMutationOutput>;
  /** Create multiple bets, funded from various player balances. Multi-match bets will be split into their own bet slip. */
  placeOmniBalanceBets?: Maybe<Array<Maybe<BetSlip>>>;
  /** Reset the password */
  resetPassword?: Maybe<UserMutationOutput>;
  /** Reset user password via SMS */
  resetPasswordSms?: Maybe<User>;
  sendEmailVerificationCode?: Maybe<AuthIsAdminResult>;
  sendSmsVerificationCode?: Maybe<AuthIsAdminResult>;
  /** Send user traits to analytics */
  sendUserExternalOfferTraits?: Maybe<Scalars['Boolean']>;
  /** Submit a deposit */
  submitDeposit?: Maybe<DepositResponse>;
  /** Submit additional details required for a deposit */
  submitDepositAdditionalDetails?: Maybe<DepositResponse>;
  /** Submit a withdrawal */
  submitWithdrawal?: Maybe<WithdrawalResponse>;
  syncUserAndGame?: Maybe<Scalars['Boolean']>;
  /**
   * unlink the users game identifier for a riot game
   * @deprecated No longer supported
   */
  unlinkRiotCredentials?: Maybe<Scalars['Boolean']>;
  /** unlink a users platform identifier for Steam */
  unlinkSteamCredentials?: Maybe<Scalars['Boolean']>;
  /** unlink the users platform identifier for a twitch */
  unlinkTwitchCredentials?: Maybe<Scalars['Boolean']>;
  /** Update device bits with Apple */
  updateDeviceBits?: Maybe<VerifyDeviceResponse>;
  /** Set user fair play terms agreement for game */
  updateGameFairPlayTermsAgreement?: Maybe<Scalars['Boolean']>;
  /** Reset password via verification code or old password */
  updatePassword?: Maybe<Scalars['Boolean']>;
  /** Update a users platform and game identifier */
  updatePlatformAndGameIdentifier?: Maybe<UserMutationOutput>;
  /** Admin Manually Update a User's verification status. */
  updateReviewUserVerificationStatus?: Maybe<UserMutationOutput>;
  /** Set users twitch audio acknowledgement */
  updateTwitchMute?: Maybe<Scalars['Boolean']>;
  /** Update flag for user */
  updateUserFlag?: Maybe<UserSetFlagsMutationOutput>;
  /** Update a User's Password */
  updateUserPassword?: Maybe<UserMutationOutput>;
  /** Update a User's verification status. */
  updateUserVerificationStatus?: Maybe<UserMutationOutput>;
  /** Update a users lounge username */
  updateUsername?: Maybe<User>;
  /** Fetch and verify a device with Apple */
  verifyDevice?: Maybe<VerifyDeviceResponse>;
};


export type RootMutationTypeAdminSetUserLockArgs = {
  id?: InputMaybe<Scalars['ID']>;
  lockReason?: InputMaybe<Scalars['String']>;
  locked?: InputMaybe<Scalars['Boolean']>;
};


export type RootMutationTypeAdminSetUserUnderReviewArgs = {
  id?: InputMaybe<Scalars['ID']>;
  underReview?: InputMaybe<Scalars['Boolean']>;
  underReviewReason?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeAdminToggleMinimumGameRequirementForStakableGameArgs = {
  gameSlug?: InputMaybe<Games>;
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeAdminUpdateTwitchMuteArgs = {
  game: Games;
  twitchMuted: Scalars['Boolean'];
  userId: Scalars['ID'];
};


export type RootMutationTypeAdminUpdateUserPasswordArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<AdminUpdateUserPasswordInput>;
};


export type RootMutationTypeAuthenticateUserArgs = {
  input?: InputMaybe<AuthenticateUserInput>;
};


export type RootMutationTypeCancelBetByGroupBetIdArgs = {
  input?: InputMaybe<CancelBetByGroupBetIdInput>;
};


export type RootMutationTypeCancelWithdrawalArgs = {
  withdrawalId: Scalars['ID'];
};


export type RootMutationTypeClaimExternalOfferArgs = {
  offerId: Scalars['ID'];
};


export type RootMutationTypeCreateAccountStepOneArgs = {
  input?: InputMaybe<CreateAccountStepOneInput>;
};


export type RootMutationTypeCreateAccountStepThreeArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<CreateAccountStepThreeInput>;
};


export type RootMutationTypeCreateGameSpecificTeamArgs = {
  input?: InputMaybe<CreateGameSpecificTeamInput>;
};


export type RootMutationTypeCreateNoteForUserArgs = {
  authorEmail: Scalars['String'];
  text: Scalars['String'];
  userId: Scalars['ID'];
};


export type RootMutationTypeCreateOnfidoTokenArgs = {
  input?: InputMaybe<OnfidoCreateTokenInput>;
};


export type RootMutationTypeCreatePlatformAndGameIdentifierArgs = {
  game?: InputMaybe<Games>;
  identifier: Scalars['String'];
  platform: Platforms;
};


export type RootMutationTypeCreatePlatformAndGameIdentifierAsyncArgs = {
  game?: InputMaybe<Games>;
  identifier: Scalars['String'];
  platform: Platforms;
};


export type RootMutationTypeCreateStakeOrderArgs = {
  fundingSources: Array<InputMaybe<FinancialsInput>>;
  offerId: Scalars['String'];
};


export type RootMutationTypeCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type RootMutationTypeCreateUserEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeDeleteTwitchEventSubscriptionArgs = {
  id: Scalars['String'];
};


export type RootMutationTypeDeleteTwitchEventSubscriptionsByUserArgs = {
  id: Scalars['ID'];
};


export type RootMutationTypeDeleteTwitchEventSubscriptionsByUserIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type RootMutationTypeDisableUserTeamsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeFetchUserMatchDataArgs = {
  id?: InputMaybe<Scalars['ID']>;
  searchTrigger?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeForgotPasswordArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeForgotPasswordVerificationArgs = {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeInsertSpecialRuleUserArgs = {
  input?: InputMaybe<InsertSpecialRuleUserInput>;
};


export type RootMutationTypeLinkRiotCredentialsArgs = {
  code: Scalars['String'];
  game?: InputMaybe<Games>;
};


export type RootMutationTypeLinkSteamCredentialsArgs = {
  url: Scalars['String'];
};


export type RootMutationTypeLinkTwitchCredentialsArgs = {
  code: Scalars['String'];
};


export type RootMutationTypePayoutUserPtrArgs = {
  input?: InputMaybe<PtrPayoutInput>;
};


export type RootMutationTypePaypalTransactionProcessArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<PaypalTransactionProcessInput>;
};


export type RootMutationTypePlaceOmniBalanceBetsArgs = {
  input?: InputMaybe<PlaceOmniBalanceBetInput>;
};


export type RootMutationTypeResetPasswordArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeResetPasswordSmsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootMutationTypeSendEmailVerificationCodeArgs = {
  input?: InputMaybe<SendEmailVerificationCodeInput>;
};


export type RootMutationTypeSendSmsVerificationCodeArgs = {
  input?: InputMaybe<SendSmsVerificationCodeInput>;
};


export type RootMutationTypeSubmitDepositArgs = {
  amount: Scalars['Int'];
  depositFeeAmount?: InputMaybe<Scalars['Int']>;
  provider: ProviderEnum;
  providerDepositDetails: ProviderDetailsInput;
  savePaymentMethod: Scalars['Boolean'];
};


export type RootMutationTypeSubmitDepositAdditionalDetailsArgs = {
  provider: ProviderEnum;
  providerDepositAdditionalDetails: Scalars['String'];
  providerRef?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type RootMutationTypeSubmitWithdrawalArgs = {
  amount: Scalars['Int'];
  expediteTier: ExpediteTierEnum;
  provider: ProviderEnum;
  providerWithdrawalDetails: ProviderDetailsInput;
};


export type RootMutationTypeSyncUserAndGameArgs = {
  game?: InputMaybe<Games>;
};


export type RootMutationTypeUnlinkRiotCredentialsArgs = {
  game?: InputMaybe<Games>;
};


export type RootMutationTypeUpdateDeviceBitsArgs = {
  bit0: Scalars['Boolean'];
  bit1: Scalars['Boolean'];
  deviceToken: Scalars['String'];
};


export type RootMutationTypeUpdateGameFairPlayTermsAgreementArgs = {
  game: Games;
  termsAgreed: Scalars['Boolean'];
};


export type RootMutationTypeUpdatePasswordArgs = {
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  resetCode?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdatePlatformAndGameIdentifierArgs = {
  game?: InputMaybe<Games>;
  identifier: Scalars['String'];
  newGamerTag?: InputMaybe<Scalars['String']>;
  newPlatform?: InputMaybe<Platforms>;
  platform: Platforms;
};


export type RootMutationTypeUpdateReviewUserVerificationStatusArgs = {
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<OnfidoVerificationStatus>;
  workflowRunId?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeUpdateTwitchMuteArgs = {
  game: Games;
  twitchMuted: Scalars['Boolean'];
};


export type RootMutationTypeUpdateUserFlagArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<SetUserFlagInput>;
};


export type RootMutationTypeUpdateUserPasswordArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateUserPasswordInput>;
};


export type RootMutationTypeUpdateUserVerificationStatusArgs = {
  status?: InputMaybe<OnfidoVerificationStatus>;
};


export type RootMutationTypeUpdateUsernameArgs = {
  newUsername?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeVerifyDeviceArgs = {
  deviceToken: Scalars['String'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Check if a user can deposit with the specified provider */
  canUserDepositWithProvider?: Maybe<Scalars['Boolean']>;
  /** Get a User by their email address */
  currentUser?: Maybe<User>;
  /** Get all active providers and their expedite tiers */
  getActiveProviders?: Maybe<Array<Maybe<ProviderConfigResponse>>>;
  /** Get all available stake offers */
  getAvailableStakeOffers?: Maybe<StakeOfferPaginated>;
  /** Get a User bet history for logged in user */
  getBetHistory?: Maybe<BetHistoryResponse>;
  /** Get a User bet history for provided user id */
  getBetHistoryByUserId?: Maybe<BetHistoryResponse>;
  /** Get a Bet by ID */
  getBetSlip?: Maybe<BetSlip>;
  /** Get all active deposit providers and their payment methods */
  getDepositMethods?: Maybe<Array<Maybe<DepositProviderResponse>>>;
  /** Get all available ads */
  getExternalAds?: Maybe<Array<Maybe<ExternalPartnerAd>>>;
  /** Get all available and claimed external offers */
  getExternalOffers?: Maybe<ExternalOffersResponse>;
  /** Get a Feature Flag by domain */
  getFeatureFlag?: Maybe<Feature>;
  /** Get inplay stake offers */
  getInplayStakeOffers?: Maybe<StakeOfferPaginated>;
  /** Get ptrs by user */
  getPtrs?: Maybe<Array<Maybe<Ptr>>>;
  /** Get a Referral code by code */
  getReferralCodeByCode?: Maybe<ReferralCode>;
  /** Get a Referral code by user_id */
  getReferralCodeForUserId?: Maybe<ReferralCode>;
  getStakeOfferById?: Maybe<StakeOffer>;
  getStakeOffersByUser?: Maybe<StakeOfferPaginated>;
  getStakeOrdersByUser?: Maybe<StakeOrderPaginated>;
  getStakeOrdersByUserId?: Maybe<StakeOrderPaginated>;
  /** Get stake session feed */
  getStakeSessionFeed?: Maybe<StakeSessionsPaginated>;
  getStakesOrderById?: Maybe<StakeOrder>;
  /** Get Teams based on the specified filter */
  getTeams?: Maybe<Array<Maybe<Team>>>;
  /** Get a users relevanta VODs based on a timestamp */
  getThisNow?: Maybe<Array<Maybe<TwitchVod>>>;
  /** Get a User by their email address */
  getUserByEmail?: Maybe<User>;
  /** Get a User by their ID */
  getUserById: User;
  /** Get a User by their email address */
  getUserByPhone?: Maybe<User>;
  /** Get a users deposit and withdrawal limits by their id */
  getUserDepositWithdrawLimits?: Maybe<UserLimits>;
  /** Get all of a user's notes */
  getUserGameHistory?: Maybe<GameHistoryOutput>;
  /** Get a users game statistics */
  getUserGameStatistics?: Maybe<Array<Maybe<UserGameStatistics>>>;
  /** Get all of a user's notes */
  getUserNotes?: Maybe<Array<Maybe<Note>>>;
  /** Get user referrals by user */
  getUserReferrals?: Maybe<Array<Maybe<UserReferral>>>;
  /** Get user referrals by referral codes */
  getUserReferralsForUserId?: Maybe<Array<Maybe<UserReferral>>>;
  getUserStakingStats?: Maybe<StakeUserGameStats>;
  /** Get a specific transaction for a user */
  getUserTransactionById?: Maybe<WalletApiTransactionHistory>;
  /** Get a users transaction history */
  getUserTransactionHistory?: Maybe<TransactionHistoryResponse>;
  /** Get a users subscriptions */
  getUserTwitchEventSubscriptions?: Maybe<TwitchUserSubscriptionResponse>;
  /** Get a users wallet stats */
  getUserWalletStats?: Maybe<UserWalletStats>;
  /** Get payment withdrawal by id */
  getUserWithdrawalById?: Maybe<WithdrawalResponse>;
  /** Get all of a user's withdrawals */
  getUserWithdrawals?: Maybe<Array<Maybe<WithdrawalResponse>>>;
  /** Get a users relevant VODs based on a timestamp */
  getVodsByTimestamp?: Maybe<Array<Maybe<TwitchVod>>>;
  /** Exposes any node given its global ID. */
  node?: Maybe<Node>;
  nodes: Array<Maybe<Node>>;
  /** Gets a selection of users and platforms matching the provided string */
  searchForPlayersByGamertag: SearchResults;
};


export type RootQueryTypeCanUserDepositWithProviderArgs = {
  provider: ProviderEnum;
};


export type RootQueryTypeCurrentUserArgs = {
  associatedGameModes?: InputMaybe<Array<Scalars['String']>>;
};


export type RootQueryTypeGetAvailableStakeOffersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetBetHistoryArgs = {
  gameSlug?: InputMaybe<Games>;
  page?: InputMaybe<Scalars['Int']>;
  resolutionType?: InputMaybe<FilterStatus>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetBetHistoryByUserIdArgs = {
  gameSlug?: InputMaybe<Games>;
  page?: InputMaybe<Scalars['Int']>;
  resolutionType?: InputMaybe<FilterStatus>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type RootQueryTypeGetBetSlipArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetFeatureFlagArgs = {
  input?: InputMaybe<GetFeatureFlagInput>;
};


export type RootQueryTypeGetInplayStakeOffersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetReferralCodeByCodeArgs = {
  code: Scalars['String'];
};


export type RootQueryTypeGetStakeOfferByIdArgs = {
  offerId: Scalars['String'];
};


export type RootQueryTypeGetStakeOffersByUserArgs = {
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetStakeOrdersByUserArgs = {
  filter?: InputMaybe<StakeOrderFilter>;
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetStakeOrdersByUserIdArgs = {
  filter?: InputMaybe<StakeOrderFilter>;
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};


export type RootQueryTypeGetStakeSessionFeedArgs = {
  excludedOfferIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetStakesOrderByIdArgs = {
  orderId: Scalars['String'];
};


export type RootQueryTypeGetTeamsArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type RootQueryTypeGetThisNowArgs = {
  id: Scalars['String'];
  timestamp: Scalars['DateTime'];
};


export type RootQueryTypeGetUserByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetUserByIdArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetUserByPhoneArgs = {
  phone?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetUserGameHistoryArgs = {
  game: Games;
  gameMode?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetUserGameStatisticsArgs = {
  game: Games;
  userId: Scalars['String'];
};


export type RootQueryTypeGetUserNotesArgs = {
  userId: Scalars['ID'];
};


export type RootQueryTypeGetUserReferralsForUserIdArgs = {
  userId: Scalars['String'];
};


export type RootQueryTypeGetUserTransactionByIdArgs = {
  transactionId?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTypeGetUserTransactionHistoryArgs = {
  balanceType?: InputMaybe<BalanceType>;
  order?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type RootQueryTypeGetUserTwitchEventSubscriptionsArgs = {
  id: Scalars['String'];
};


export type RootQueryTypeGetUserWalletStatsArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeGetUserWithdrawalByIdArgs = {
  withdrawalId?: InputMaybe<Scalars['String']>;
};


export type RootQueryTypeGetUserWithdrawalsArgs = {
  status?: InputMaybe<WithdrawalStatus>;
};


export type RootQueryTypeGetVodsByTimestampArgs = {
  id: Scalars['String'];
  timestamp: Scalars['DateTime'];
};


export type RootQueryTypeNodeArgs = {
  id: Scalars['ID'];
};


export type RootQueryTypeNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type RootQueryTypeSearchForPlayersByGamertagArgs = {
  username: Scalars['String'];
};

/** An object containing list of users and a list of user_platform objects */
export type SearchResults = {
  __typename?: 'SearchResults';
  /** A list of objects containing matching platform usernames and the associated users id */
  results: Array<Maybe<UserPlatform>>;
  /** A list of users found by the search */
  users: Array<Maybe<User>>;
};

export type SendEmailVerificationCodeInput = {
  email: Scalars['String'];
  isSignup?: InputMaybe<Scalars['Boolean']>;
};

export type SendSmsVerificationCodeInput = {
  isSignup?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
};

export type SetUserFlagInput = {
  flag?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Settled Bet Count */
export type SettledBetCounts = Node & {
  __typename?: 'SettledBetCounts';
  betValue?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  settledBetCount?: Maybe<Scalars['Int']>;
  systemBypassed?: Maybe<Scalars['Boolean']>;
  systemDisabled?: Maybe<Scalars['Boolean']>;
};

/** Settled Bet Denomination Counts */
export type SettledBetDenominationCounts = Node & {
  __typename?: 'SettledBetDenominationCounts';
  fifty?: Maybe<Scalars['Int']>;
  fiftyMmb?: Maybe<Scalars['Int']>;
  five?: Maybe<Scalars['Int']>;
  fiveMmb?: Maybe<Scalars['Int']>;
  /** The ID of an object */
  id: Scalars['ID'];
  one?: Maybe<Scalars['Int']>;
  oneMmb?: Maybe<Scalars['Int']>;
  onehundred?: Maybe<Scalars['Int']>;
  onehundredMmb?: Maybe<Scalars['Int']>;
  ten?: Maybe<Scalars['Int']>;
  tenMmb?: Maybe<Scalars['Int']>;
  three?: Maybe<Scalars['Int']>;
  threeMmb?: Maybe<Scalars['Int']>;
  twentyfive?: Maybe<Scalars['Int']>;
  twentyfiveMmb?: Maybe<Scalars['Int']>;
};

/** A bounty bet */
export type SingleGameTeamBountyOption = {
  __typename?: 'SingleGameTeamBountyOption';
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Bet level */
  level: Scalars['String'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** List of ranges for the user to target */
  ranges: Array<Maybe<BountyRange>>;
  /** If the bet should be selected */
  selected: Scalars['Boolean'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
  /** The amount won on the bet */
  win: Scalars['String'];
};

/** A single option for a bet */
export type SingleGameTeamOption = {
  __typename?: 'SingleGameTeamOption';
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Bet level */
  level: Scalars['String'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String'];
  /** If the bet should be selected */
  selected: Scalars['Boolean'];
  /** The title of the bet option */
  title: Scalars['String'];
  /** how to display the title */
  titleDisplayStrategy: BetDisplayOptions;
  /** The amount won on the bet */
  win: Scalars['String'];
};

/** A parlay bet option */
export type SingleGameTeamParlayOption = {
  __typename?: 'SingleGameTeamParlayOption';
  /** ID */
  id?: Maybe<Scalars['ID']>;
  /** Bet level */
  level: Scalars['String'];
  /** The amount returned from the bet (ante + win) */
  payout: Scalars['String'];
  /** A multiplier describing the relationship between the ante and the payout */
  payoutMultiplier: Scalars['String'];
  /** Parlay requirements */
  requirements: Array<ParlayBetItem>;
  /** If the bet should be selected */
  selected: Scalars['Boolean'];
  /** The amount won on the bet */
  win: Scalars['String'];
};

/** Represents a special rule user object */
export type SpecialRuleUser = {
  __typename?: 'SpecialRuleUser';
  id?: Maybe<Scalars['String']>;
  lastSeenTs?: Maybe<Scalars['DateTime']>;
  ruleId?: Maybe<Scalars['String']>;
  ruleVersion?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
};

export type SpecialRuleUserInput = {
  ruleId?: InputMaybe<Scalars['String']>;
  ruleVersion?: InputMaybe<Scalars['Int']>;
};

export type SpecialRuleUserMutationOutput = {
  __typename?: 'SpecialRuleUserMutationOutput';
  id?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<SpecialRuleUser>>>;
};

export type SpecialRules = {
  __typename?: 'SpecialRules';
  betLineTypes: Array<Scalars['String']>;
  gameModes: Array<SpecialRulesGameMode>;
  id: Scalars['ID'];
  ruleDisplay: Array<Scalars['String']>;
  systemId: Scalars['String'];
};

export type SpecialRulesGameMode = {
  __typename?: 'SpecialRulesGameMode';
  systemId: Scalars['String'];
};

/** Bet item adjustment details specifically for stake offers */
export type StakeBetItemAdjustment = {
  __typename?: 'StakeBetItemAdjustment';
  adjustedBy: Scalars['String'];
  adjustmentReason: Scalars['String'];
  betItemId: Scalars['String'];
  betSlipAdjustmentId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  newAchievedMultiplier: Scalars['Int'];
  newAchievedValue: Scalars['Int'];
  newWon: Scalars['Boolean'];
  offerAdjustmentId: Scalars['String'];
  oldAchievedMultiplier: Scalars['Int'];
  oldAchievedValue: Scalars['Int'];
  oldWon: Scalars['Boolean'];
  updatedAt: Scalars['String'];
};

/** Stake Offer details */
export type StakeOffer = {
  __typename?: 'StakeOffer';
  achievedMultiplier?: Maybe<Scalars['Int']>;
  adjustments?: Maybe<Array<Maybe<StakeOfferAdjustment>>>;
  createdAt: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  fundingSource: Array<Maybe<Financials>>;
  id: Scalars['String'];
  maximumAllowedStake?: Maybe<Scalars['String']>;
  maximumAllowedStakeForUser?: Maybe<Scalars['String']>;
  maximumMultiplier: Scalars['Int'];
  orders?: Maybe<Array<Maybe<StakeOrder>>>;
  productId: Scalars['String'];
  productInfo: Product;
  productType: Scalars['String'];
  reward?: Maybe<StakeOfferReward>;
  status: Scalars['String'];
  updatedAt: Scalars['String'];
  /** Stake offer owner */
  user: User;
};

/** Stake offer adjustment details */
export type StakeOfferAdjustment = {
  __typename?: 'StakeOfferAdjustment';
  adjustedBy: Scalars['String'];
  adjustmentReason: Scalars['String'];
  betSlipAdjustmentId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  newAchievedMultiplier: Scalars['Int'];
  oldAchievedMultiplier: Scalars['Int'];
  productAdjustments?: Maybe<Array<StakeBetItemAdjustment>>;
  updatedAt: Scalars['String'];
};

/** Paginated response for available stakes */
export type StakeOfferPaginated = {
  __typename?: 'StakeOfferPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** Array of Stake offers */
  stakeOffers?: Maybe<Array<Maybe<StakeOffer>>>;
};

export type StakeOfferReward = {
  __typename?: 'StakeOfferReward';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  rewards: Array<Maybe<Financials>>;
};

/** Stake order details */
export type StakeOrder = {
  __typename?: 'StakeOrder';
  achievedMultiplier?: Maybe<Scalars['Int']>;
  adjustments?: Maybe<Array<Maybe<StakeOrderAdjustment>>>;
  createdAt: Scalars['String'];
  fundingSource: Array<Maybe<Financials>>;
  id: Scalars['String'];
  offer?: Maybe<StakeOffer>;
  payout?: Maybe<StakeOrderPayout>;
  serviceFee: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['String'];
  user: User;
};

/** Stake order adjustment details */
export type StakeOrderAdjustment = {
  __typename?: 'StakeOrderAdjustment';
  adjustedBy: Scalars['String'];
  adjustmentReason: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  metadata?: Maybe<StakeOrderAdjustmentMetadata>;
  newAchievedMultiplier: Scalars['Int'];
  newPayouts: Array<Financials>;
  offerAdjustmentId: Scalars['String'];
  oldAchievedMultiplier: Scalars['Int'];
  oldPayouts: Array<Financials>;
  updatedAt: Scalars['String'];
};

export type StakeOrderAdjustmentMetadata = {
  __typename?: 'StakeOrderAdjustmentMetadata';
  outstandingAmounts?: Maybe<Array<Financials>>;
};

export enum StakeOrderFilter {
  /** Get all orders that are in a completed state */
  COMPLETE = 'COMPLETE',
  /** Get all orders that are in a pending state */
  PENDING = 'PENDING'
}

/** Paginated response for available stakes */
export type StakeOrderPaginated = {
  __typename?: 'StakeOrderPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** Array of Stake offers */
  stakeOrders?: Maybe<Array<Maybe<StakeOrder>>>;
};

export type StakeOrderPayout = {
  __typename?: 'StakeOrderPayout';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  payouts: Array<Maybe<Financials>>;
};

/** Stake session */
export type StakeSession = {
  __typename?: 'StakeSession';
  offers: Array<Maybe<StakeOffer>>;
  user: User;
};

/** Paginated response for stake sessions */
export type StakeSessionsPaginated = {
  __typename?: 'StakeSessionsPaginated';
  /** Pagination information */
  metaData?: Maybe<PaginationDetails>;
  /** Array of Stake sessions */
  stakeSessions?: Maybe<Array<Maybe<StakeSession>>>;
};

/** Response for user stats */
export type StakeUserGameStats = {
  __typename?: 'StakeUserGameStats';
  /** Array of user game stats */
  userGameInfo?: Maybe<Array<Maybe<UserGameInfo>>>;
  /** Array of user partnership game stats */
  userPartnershipGameInfo?: Maybe<Array<Maybe<UserPartnershipGameInfo>>>;
};

/** A status of a withdrawal request */
export type Status = {
  __typename?: 'Status';
  /** When the status was first created */
  createdAt: Scalars['String'];
  /** The ID of the withdrawal */
  id: Scalars['ID'];
  /** Payment status ID */
  paymentStatusId: Scalars['ID'];
  /** The status of the withdrawal */
  status: WithdrawalStatus;
  /** What entity initiated the request (e.g, 'user') */
  trigger: Scalars['String'];
  /** Trigger relationship reason */
  triggerReason: Scalars['String'];
  /** Triggered by */
  triggeredBy: Scalars['String'];
  /** When the status was last updated */
  updatedAt: Scalars['String'];
};

export type StoredPaymentMethod = {
  __typename?: 'StoredPaymentMethod';
  /** The bank accound number (without separators) */
  bankAccountNumber?: Maybe<Scalars['String']>;
  /** The location id of the bank. The field value is nil in most cases */
  bankLocationId?: Maybe<Scalars['String']>;
  /** The brand of the card */
  brand?: Maybe<Scalars['String']>;
  /** The month the card expires */
  expiryMonth?: Maybe<Scalars['String']>;
  /** The last two digits of the year the card expires. For example, 22 for the year 2022 */
  expiryYear?: Maybe<Scalars['String']>;
  /** The unique payment method code */
  holderName?: Maybe<Scalars['String']>;
  /** The IBAN of the bank account */
  iban?: Maybe<Scalars['String']>;
  /** A unique identifier of this stored payment method */
  id: Scalars['String'];
  /** Flag to indicate whether this stored payment method is the last used payment method */
  isLastUsedPaymentMethod: Scalars['Boolean'];
  /** The shopper's issuer account label */
  label?: Maybe<Scalars['String']>;
  /** The last four digits of the PAN */
  lastFour?: Maybe<Scalars['String']>;
  /** The display name of the stored payment method */
  name: Scalars['String'];
  /** The name of the bank account holder */
  ownerName?: Maybe<Scalars['String']>;
  /** The shopper's email address */
  shopperEmail?: Maybe<Scalars['String']>;
  /** The supported recurring processing models for this stored payment method */
  supportedRecurringProcessingModels?: Maybe<Array<Scalars['String']>>;
  /** The supported shopper interactions for this stored payment method */
  supportedShopperInteractions?: Maybe<Array<Scalars['String']>>;
  /** The type of payment method */
  type: Scalars['String'];
};

/** Information collected when stream went live */
export type StreamInfo = {
  __typename?: 'StreamInfo';
  gameName?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  viewerCount?: Maybe<Scalars['Int']>;
};

export type SubscriptionCondition = {
  __typename?: 'SubscriptionCondition';
  /** Subscription condition */
  broadcasterUserId?: Maybe<Scalars['String']>;
};

export type SubscriptionData = {
  __typename?: 'SubscriptionData';
  condition?: Maybe<SubscriptionCondition>;
  cost?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  /** Subscription data */
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transport?: Maybe<SubscriptionTransport>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type SubscriptionTransport = {
  __typename?: 'SubscriptionTransport';
  callback?: Maybe<Scalars['String']>;
  /** Subscription transport */
  method?: Maybe<Scalars['String']>;
};

/** Represents a cod team entity. */
export type Team = Node & {
  __typename?: 'Team';
  betCategory: Scalars['String'];
  gameMode?: Maybe<Scalars['String']>;
  gameSlug: Scalars['String'];
  /** The ID of an object */
  id: Scalars['ID'];
  /** The entity's creation timestmap. */
  insertedAt: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  lines: Array<BetLineItem>;
  matchMap: Scalars['String'];
  owner: User;
  probabilitiesCalculated: Probabilities;
  serviceFee: Scalars['String'];
  squadSize: Scalars['Int'];
  teammateBetRestrictions: Array<TeammateBetRestriction>;
  teammates: Array<Maybe<Teammate>>;
  /** The entity's last update timestamp. */
  updatedAt: Scalars['DateTime'];
};


/** Represents a cod team entity. */
export type TeamTeammateBetRestrictionsArgs = {
  associatedGameModes?: InputMaybe<Array<Scalars['String']>>;
};

/** A list of cod teams. */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  pageInfo: PageInfo;
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<Team>;
};

export type TeamMutationOutput = Node & {
  __typename?: 'TeamMutationOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID'];
  result?: Maybe<Team>;
};

/** Represents a cod teammate entity. */
export type Teammate = Node & {
  __typename?: 'Teammate';
  /** The ID of an object */
  id: Scalars['ID'];
  /** The entity's creation timestmap. */
  insertedAt: Scalars['DateTime'];
  /** The platofrm that the user play's on. */
  lobbyPlatform: Scalars['String'];
  team: Team;
  /** The entity's last update timestamp. */
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type TeammateBetRestriction = {
  __typename?: 'TeammateBetRestriction';
  gameModeBetRestrictions: Array<GameModeBetRestriction>;
  userId: Scalars['String'];
};

/** The response for a paginated transaction history request */
export type TransactionHistoryResponse = {
  __typename?: 'TransactionHistoryResponse';
  /** Array of transaction history entities */
  data: Array<Maybe<WalletApiTransactionHistory>>;
  /** Pagination information */
  metadata: PaginationDetails;
};

/** Twitch Profile Information */
export type TwitchProfileInfo = {
  __typename?: 'TwitchProfileInfo';
  description?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  twitchCreatedAt?: Maybe<Scalars['String']>;
};

export type TwitchSubscriptionDeletionResponse = {
  __typename?: 'TwitchSubscriptionDeletionResponse';
  /** The Twitch subscription deletion response */
  success?: Maybe<Scalars['Boolean']>;
};

export type TwitchUserSubscriptionDeletionResponse = {
  __typename?: 'TwitchUserSubscriptionDeletionResponse';
  subscriptionId?: Maybe<Scalars['String']>;
  /** The Twitch subscription deletion response */
  success?: Maybe<Scalars['Boolean']>;
  twitchId?: Maybe<Scalars['String']>;
};

export type TwitchUserSubscriptionResponse = {
  __typename?: 'TwitchUserSubscriptionResponse';
  data?: Maybe<Array<Maybe<SubscriptionData>>>;
  maxTotalCost?: Maybe<Scalars['Int']>;
  /** The Twitch user subscription response */
  total?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Scalars['Int']>;
};

/** Twitch VODs */
export type TwitchVod = {
  __typename?: 'TwitchVod';
  twitchVodCreatedAt?: Maybe<Scalars['DateTime']>;
  twitchVodDuration?: Maybe<Scalars['String']>;
  twitchVodId?: Maybe<Scalars['String']>;
  twitchVodLink?: Maybe<Scalars['String']>;
};

export type UpdateUserPasswordInput = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

/** Represents a cod user entity. */
export type User = Node & {
  __typename?: 'User';
  /** The type of account the user has, e.g. standard, partner, admin */
  accountType?: Maybe<Scalars['String']>;
  /** The user's one and only current active team, if there is one */
  activeTeam?: Maybe<Team>;
  ageVerified: Scalars['Boolean'];
  dateOfBirth?: Maybe<Scalars['String']>;
  /** The user's email address */
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  /** The user's financial data */
  financials: Array<Financials>;
  firstName?: Maybe<Scalars['String']>;
  flags?: Maybe<UserFlags>;
  /** platform status */
  gamePlatformStatus: Array<GamePlatformStatus>;
  gender?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
  idVerificationDate?: Maybe<Scalars['DateTime']>;
  idVerificationStatus?: Maybe<VerificationStatus>;
  /** The entity's creation timestmap. */
  insertedAt: Scalars['DateTime'];
  lastName?: Maybe<Scalars['String']>;
  lockedStatus?: Maybe<LockedStatus>;
  /** PL internal username */
  loungeUsername?: Maybe<Scalars['String']>;
  loungeUsernameLastUpdatedAt?: Maybe<Scalars['DateTime']>;
  middleName?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  /** The notes for this user */
  notes?: Maybe<NoteConnection>;
  onfidoApplicantId?: Maybe<Scalars['String']>;
  onfidoLatestTransactionId?: Maybe<Scalars['String']>;
  passwordHash: Scalars['String'];
  /** The user's phone number */
  phone?: Maybe<Scalars['String']>;
  plCoreUserId?: Maybe<Scalars['String']>;
  /** Platform Identifiers */
  platformIdentifiers?: Maybe<Array<Maybe<PlatformIdentifier>>>;
  promoCode?: Maybe<Scalars['String']>;
  /** Playthrough Requirements */
  ptrs?: Maybe<Array<Maybe<Ptr>>>;
  /** the users referral codes */
  referralCodes?: Maybe<Array<Maybe<ReferralCode>>>;
  stakingStats?: Maybe<StakeUserGameStats>;
  /** Where the user is upto in registering, step 3 is complete */
  stepRegister: Scalars['String'];
  /** The teams this user is a member of */
  teams?: Maybe<TeamConnection>;
  underReview?: Maybe<Scalars['Boolean']>;
  /** The entity's last update timestamp. */
  updatedAt: Scalars['DateTime'];
  userBettingStatus: Array<UserBettingStatus>;
  /** the users referred users */
  userReferrals?: Maybe<Array<Maybe<UserReferral>>>;
  /** the users seen special rules */
  userSpecialRules?: Maybe<Array<Maybe<SpecialRuleUser>>>;
  userStakingStatus: Array<UserStakingOfferStatus>;
  verifiedDocument?: Maybe<Scalars['String']>;
  walletStats?: Maybe<UserWalletStats>;
};


/** Represents a cod user entity. */
export type UserGamePlatformStatusArgs = {
  game?: InputMaybe<Games>;
};


/** Represents a cod user entity. */
export type UserNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents a cod user entity. */
export type UserTeamsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Represents a cod user entity. */
export type UserUserBettingStatusArgs = {
  game?: InputMaybe<Games>;
};

export type UserBettingStatus = {
  __typename?: 'UserBettingStatus';
  /** The game that this betting status is for */
  game: Games;
  /** The status for this betting status */
  status: UserBettingStatuses;
};

export enum UserBettingStatuses {
  /** User can bet */
  CAN_BET = 'CAN_BET',
  /** The user hasn't yet accepted the fair play terms */
  FAIR_PLAY_TERMS_NOT_ACCEPTED = 'FAIR_PLAY_TERMS_NOT_ACCEPTED',
  /** User locked by admin */
  LOCKED_BY_ADMIN = 'LOCKED_BY_ADMIN',
  /** Not enough matches stored for the given game(s) */
  NOT_ENOUGH_MATCHES_FOR_GAME = 'NOT_ENOUGH_MATCHES_FOR_GAME',
  /** Platform status for game not ready */
  PLATFORM_NOT_READY = 'PLATFORM_NOT_READY',
  /** System betting flag has been disabled */
  SYSTEM_BETTING_DISABLED = 'SYSTEM_BETTING_DISABLED',
  /** Linking of an account that differs from previous twitch account was linked */
  TWITCH_ALTERNATE_ACCOUNT = 'TWITCH_ALTERNATE_ACCOUNT',
  /** Currently linking twitch account */
  TWITCH_LINKING = 'TWITCH_LINKING',
  /** Twitch needs reauthorisation */
  TWITCH_NEED_REAUTH = 'TWITCH_NEED_REAUTH',
  /** Twitch is required but not linked */
  TWITCH_NOT_LINKED = 'TWITCH_NOT_LINKED',
  /** The user hasn't acknowledged muting settings */
  TWITCH_NOT_MUTED = 'TWITCH_NOT_MUTED',
  /** The user is not currently streaming on twitch */
  TWITCH_NOT_STREAMING = 'TWITCH_NOT_STREAMING',
  /** Failed to fetch the twitch token */
  TWITCH_TOKEN_FETCH_FAILED = 'TWITCH_TOKEN_FETCH_FAILED',
  /** Another user is already using this token */
  TWITCH_TOKEN_IN_USE = 'TWITCH_TOKEN_IN_USE',
  /** The user VOD settings could not be verified */
  TWITCH_VOD_NOT_ENABLED = 'TWITCH_VOD_NOT_ENABLED',
  /** Something went wrong checking validation. */
  UNEXPECTED_VALIDATION_ERROR = 'UNEXPECTED_VALIDATION_ERROR'
}

/** A user's flags */
export type UserFlags = {
  __typename?: 'UserFlags';
  codMatchCountBypass: Scalars['Boolean'];
  disallowBets: Scalars['Boolean'];
  disallowDeposits: Scalars['Boolean'];
  disallowWithdrawals: Scalars['Boolean'];
  mmpBetsEnabled?: Maybe<Scalars['Boolean']>;
  stakingEnabled: Scalars['Boolean'];
  stakingFairPlayTermsAccepted: Scalars['Boolean'];
};

/** Represents a user game info */
export type UserGameInfo = {
  __typename?: 'UserGameInfo';
  createdAt?: Maybe<Scalars['String']>;
  gameSlug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maximumStakeAmount?: Maybe<Scalars['Float']>;
  maximumStakeMultiplier?: Maybe<Scalars['Float']>;
  stakingOfferEnabled?: Maybe<Scalars['Boolean']>;
  stakingOrderEnabled?: Maybe<Scalars['Boolean']>;
  totalBetsStaked?: Maybe<Scalars['Int']>;
  totalServiceFeeAmount?: Maybe<Scalars['Float']>;
  totalStakedAmount?: Maybe<Array<Maybe<Financials>>>;
  totalWinnings?: Maybe<Array<Maybe<Financials>>>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserGameStatistics = {
  __typename?: 'UserGameStatistics';
  form?: Maybe<Array<Maybe<BetSlipForm>>>;
  lifetimeBetCount?: Maybe<Scalars['Int']>;
  lifetimeStakes?: Maybe<Scalars['String']>;
};

/** A user's deposit and withdrawal limits */
export type UserLimits = {
  __typename?: 'UserLimits';
  maxDailyDeposit: Scalars['String'];
  maxDailyWithdrawal: Scalars['String'];
  maxWeeklyDeposit: Scalars['String'];
  maxWeeklyWithdrawal: Scalars['String'];
  paypalWithdrawalEmail?: Maybe<Scalars['String']>;
};

export type UserMutationOutput = Node & {
  __typename?: 'UserMutationOutput';
  errors?: Maybe<Errors>;
  /** The ID of an object */
  id: Scalars['ID'];
  result?: Maybe<User>;
};

export type UserOmniBalanceBetLevelResultInput = {
  category?: InputMaybe<Scalars['String']>;
  financials: Array<InputMaybe<FinancialsInput>>;
  id?: InputMaybe<Scalars['ID']>;
  level: Scalars['Int'];
  mysteryBet?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

/** Represents a user game info */
export type UserPartnershipGameInfo = {
  __typename?: 'UserPartnershipGameInfo';
  createdAt?: Maybe<Scalars['String']>;
  gameSlug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  maximumStakeAmount?: Maybe<Scalars['Float']>;
  maximumStakeMultiplier?: Maybe<Scalars['Float']>;
  stakedUserId?: Maybe<Scalars['String']>;
  stakingOfferEnabled?: Maybe<Scalars['Boolean']>;
  stakingOrderEnabled?: Maybe<Scalars['Boolean']>;
  totalBetsStaked?: Maybe<Scalars['Int']>;
  totalServiceFeeAmount?: Maybe<Scalars['Float']>;
  totalStakedAmount?: Maybe<Array<Maybe<Financials>>>;
  totalWinnings?: Maybe<Array<Maybe<Financials>>>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** An object containing the id, platform and username of a user */
export type UserPlatform = {
  __typename?: 'UserPlatform';
  associatedPlatform: Platforms;
  associatedUsername: Scalars['String'];
  userId: Scalars['String'];
};

/** Represents a user referral */
export type UserReferral = Node & {
  __typename?: 'UserReferral';
  firstDepositPlacedCompleted?: Maybe<Scalars['Boolean']>;
  firstDepositPlacedCompletedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of an object */
  id: Scalars['ID'];
  insertedAt?: Maybe<Scalars['DateTime']>;
  payouts?: Maybe<Array<Maybe<Payout>>>;
  referralCode?: Maybe<Scalars['String']>;
  referredUser: User;
  referredUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserSetFlagsErrors = Node & {
  __typename?: 'UserSetFlagsErrors';
  code?: Maybe<Scalars['String']>;
  /** The ID of an object */
  id: Scalars['ID'];
};

export type UserSetFlagsMutationOutput = Node & {
  __typename?: 'UserSetFlagsMutationOutput';
  errors?: Maybe<UserSetFlagsErrors>;
  /** The ID of an object */
  id: Scalars['ID'];
  result?: Maybe<User>;
};

export type UserStakingOfferStatus = {
  __typename?: 'UserStakingOfferStatus';
  /** The game that this staking offer status is for */
  game: Games;
  /** The status for this staking offer status */
  status: UserStakingOfferStatuses;
};

export enum UserStakingOfferStatuses {
  /** User can create stakes when placing a bet */
  CAN_CREATE_BET = 'CAN_CREATE_BET',
  /** Game isn't supported for staking */
  GAME_NOT_SUPPORTED = 'GAME_NOT_SUPPORTED',
  /** User hasn't played enough games to be able to create stakes */
  NOT_ENOUGH_COMPLETED_MATCHES_FOR_GAME = 'NOT_ENOUGH_COMPLETED_MATCHES_FOR_GAME',
  /** Twitch needs reauthorisation */
  TWITCH_NEED_REAUTH = 'TWITCH_NEED_REAUTH',
  /** Twitch is required but not linked */
  TWITCH_NOT_LINKED = 'TWITCH_NOT_LINKED',
  /** The user hasn't acknowledged muting settings */
  TWITCH_NOT_MUTED = 'TWITCH_NOT_MUTED',
  /** The user is not currently streaming on twitch */
  TWITCH_NOT_STREAMING = 'TWITCH_NOT_STREAMING',
  /** Failed to fetch the twitch token */
  TWITCH_TOKEN_FETCH_FAILED = 'TWITCH_TOKEN_FETCH_FAILED',
  /** The user VOD settings could not be verified */
  TWITCH_VOD_NOT_ENABLED = 'TWITCH_VOD_NOT_ENABLED'
}

/** User Wallet Stats */
export type UserWalletStats = {
  __typename?: 'UserWalletStats';
  averageAmountDeposited?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cumulativeProfit?: Maybe<Scalars['String']>;
  cumulativeWinnings?: Maybe<Scalars['String']>;
  depositCount?: Maybe<Scalars['String']>;
  firstDepositAmount?: Maybe<Scalars['String']>;
  firstDepositDate?: Maybe<Scalars['String']>;
  firstDepositTransactionId?: Maybe<Scalars['ID']>;
  highestDepositAmount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mostRecentDepositAmount?: Maybe<Scalars['String']>;
  mostRecentDepositTimestamp?: Maybe<Scalars['String']>;
  totalAmountDeposited?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};

export type Valorant = {
  __typename?: 'Valorant';
  ability1Casts?: Maybe<Scalars['String']>;
  ability2Casts?: Maybe<Scalars['String']>;
  character?: Maybe<ValorantCharacter>;
  characterId?: Maybe<Scalars['String']>;
  competitiveTier?: Maybe<Scalars['String']>;
  customGameName?: Maybe<Scalars['String']>;
  gameMode?: Maybe<Scalars['String']>;
  gameName?: Maybe<Scalars['String']>;
  gameSlug: Scalars['String'];
  gameVersion?: Maybe<Scalars['String']>;
  gamerTag: Scalars['String'];
  grenadesCast?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['String']>;
  isObserver?: Maybe<Scalars['String']>;
  isRanked?: Maybe<Scalars['String']>;
  map?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  matchDuration?: Maybe<Scalars['String']>;
  matchEndDate?: Maybe<Scalars['String']>;
  matchId?: Maybe<Scalars['String']>;
  matchRegion?: Maybe<Scalars['String']>;
  matchStartDate?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['String']>;
  partyId?: Maybe<Scalars['String']>;
  playerAssists?: Maybe<Scalars['String']>;
  playerCard?: Maybe<Scalars['String']>;
  playerDeaths?: Maybe<Scalars['String']>;
  playerKills?: Maybe<Scalars['String']>;
  playerRounds?: Maybe<Scalars['Json']>;
  playerRoundsPlayed?: Maybe<Scalars['String']>;
  playerScore?: Maybe<Scalars['String']>;
  playerTitle?: Maybe<Scalars['String']>;
  playtimeMillis?: Maybe<Scalars['String']>;
  provisionFlowId?: Maybe<Scalars['String']>;
  queueId?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['String']>;
  tagLine?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  teamNumPoints?: Maybe<Scalars['String']>;
  teamRoundsPlayed?: Maybe<Scalars['String']>;
  teamRoundsWon?: Maybe<Scalars['String']>;
  teamWon?: Maybe<Scalars['String']>;
  ultimateCasts?: Maybe<Scalars['String']>;
  userIdentifier: Scalars['String'];
};

export type ValorantCharacter = {
  __typename?: 'ValorantCharacter';
  name?: Maybe<Scalars['String']>;
};

export enum VerificationStatus {
  /** User has completed verification and verification is approved */
  APPROVED = 'APPROVED',
  /** User has not started verification */
  INACTIVE = 'INACTIVE',
  /** User has started verification and verification is pending */
  PENDING = 'PENDING',
  /** User's verification was rejected */
  REJECTED = 'REJECTED',
  /** User has started verification and needs manual review */
  REVIEW = 'REVIEW'
}

/** Response returned from verifying a device with Apple */
export type VerifyDeviceResponse = {
  __typename?: 'VerifyDeviceResponse';
  /** Boolean value to determine whether the verification was successful, and the user can sign up */
  success: Scalars['Boolean'];
};

/** Represents a wallet entity. */
export type Wallet = Node & {
  __typename?: 'Wallet';
  /** Wallet Funds / Balance */
  funds: Scalars['Decimal'];
  /** The ID of an object */
  id: Scalars['ID'];
};

/** Represents a transaction history entity from the wallet api */
export type WalletApiTransactionHistory = {
  __typename?: 'WalletApiTransactionHistory';
  /** How much this transaction was for */
  amount: Scalars['String'];
  /** The balance after the transaction was completed */
  balanceAfter: Scalars['String'];
  /** The balance before the transaction was completed */
  balanceBefore: Scalars['String'];
  /** A short context for the related balance update */
  context?: Maybe<Scalars['String']>;
  /** When the transaction history entity was created */
  createdAt: Scalars['String'];
  /** The user facing description */
  description: Scalars['String'];
  /** ID of the transaction */
  id: Scalars['ID'];
  /** Any additional metadata that was added to the balance update request */
  metadata?: Maybe<WalletApiTransactionMetadata>;
  /** The triggering event for this balance update transaction history entity */
  source: Scalars['String'];
  /** The status for the related balance update */
  status?: Maybe<Scalars['String']>;
  /** The currency type for this transaction */
  type: Scalars['String'];
  /** When the transaction history entity was last updated */
  updatedAt: Scalars['String'];
  /** The user_id for this transaction */
  userId: Scalars['String'];
  /** The funding balance type for this transaction */
  wallet?: Maybe<WalletApiTransactionHistoryWallet>;
  /** The wallet ID that this transaction entity relates to */
  walletId: Scalars['Int'];
};

export type WalletApiTransactionHistoryWallet = {
  __typename?: 'WalletApiTransactionHistoryWallet';
  balance?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<WalletApiTransactionHistoryWalletType>;
  userId?: Maybe<Scalars['String']>;
};

export type WalletApiTransactionHistoryWalletType = {
  __typename?: 'WalletApiTransactionHistoryWalletType';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
};

/** Represents a transactions metadata */
export type WalletApiTransactionMetadata = {
  __typename?: 'WalletApiTransactionMetadata';
  /** The bet ID that this transaction relates to */
  betId?: Maybe<Scalars['ID']>;
  /** The brand of a card */
  brand?: Maybe<Scalars['String']>;
  /** The first six digits of a card */
  cardBin?: Maybe<Scalars['String']>;
  /** The last four digits of a card */
  cardSummary?: Maybe<Scalars['String']>;
  /** The email that was used for said transaction history entry */
  email?: Maybe<Scalars['String']>;
  /** Expected withdrawal due date */
  expectedDueDate?: Maybe<Scalars['String']>;
  /** Withdrawal expedite tier */
  expediteTier?: Maybe<Scalars['String']>;
  /** The funding source type for a card */
  fundingSource?: Maybe<Scalars['String']>;
  /** message */
  message?: Maybe<Scalars['String']>;
  /** Staking offer id */
  offerId?: Maybe<Scalars['String']>;
  /** Staking order id */
  orderId?: Maybe<Scalars['String']>;
  /** The paypal payer id */
  payerId?: Maybe<Scalars['String']>;
  /** The withdrawal id */
  paymentStatusId?: Maybe<Scalars['String']>;
  /** The paypal email used */
  paypalEmail?: Maybe<Scalars['String']>;
  /** The provider that was used for a deposit or withdrawal */
  provider?: Maybe<Scalars['String']>;
  /** The requested withdrawal amount */
  requestedWithdrawalAmount?: Maybe<Scalars['String']>;
  /** Service fee applied to the bet */
  serviceFee?: Maybe<Scalars['String']>;
  /** The tournament ID that this transaction relates to */
  tournamentId?: Maybe<Scalars['ID']>;
};

/** Metadata related to the deposit refund information */
export type WithdrawalAmendmentDepositAmount = {
  __typename?: 'WithdrawalAmendmentDepositAmount';
  /** The amount refunded for this deposit in cents */
  depositAmountRefunded: Scalars['String'];
  /** The ID of the deposit payment status */
  depositPaymentStatusId: Scalars['ID'];
};

/** Metadata related to the deposit refund information */
export type WithdrawalAmendmentInfoMetadata = {
  __typename?: 'WithdrawalAmendmentInfoMetadata';
  /** The original withdrawal amount in cents */
  originalWithdrawalAmount: Scalars['String'];
  /** The total amount refunded for deposits related to this withdrawal amendment in cents */
  totalDepositAmountRefunded: Scalars['String'];
  /** The total difference between the deposit and withdrawal amounts in cents */
  totalDifferenceBetweenDepositAndWithdrawal: Scalars['String'];
  /** A list of deposit amounts related to the withdrawal amendment */
  withdrawalAmendmentDepositAmounts?: Maybe<Array<WithdrawalAmendmentDepositAmount>>;
};

/** The information returned for all withdrawal operations */
export type WithdrawalResponse = {
  __typename?: 'WithdrawalResponse';
  /** The amount (in cents) of the withdrawal request */
  amount: Scalars['Int'];
  associatedRefundedDeposits?: Maybe<Array<Maybe<DepositResponse>>>;
  /** Payment creation date time */
  createdAt: Scalars['String'];
  /** The urgency/speed at which the user would like the withdrawl to occur ('free', 'standard', or 'expedite) */
  expediteTier: ExpediteTierEnum;
  /** Fee charged for withdrawal */
  expediteTierFee: Scalars['String'];
  /** The ID of the withdrawal */
  id: Scalars['ID'];
  /** Latest due date */
  latestDueDate: Scalars['String'];
  /** Metadata related to the payment status */
  metadata?: Maybe<PaymentStatusMetadata>;
  /** The latest status of the withdrawal request */
  mostRecentStatus: Status;
  /** The platform for this request (currently only 'paypal' is supported) */
  provider: ProviderEnum;
  /** Payment provider details */
  providerDetails: PaypalProviderDetails;
  /** Payments API user details */
  user?: Maybe<PaymentUserDetails>;
};

export enum WithdrawalStatus {
  /** Deposit or Withdrawal has been approved */
  APPROVED = 'APPROVED',
  /** Deposit or Withdrawal has been cancelled */
  CANCELLED = 'CANCELLED',
  /** Deposit or Withdrawal has been completed */
  COMPLETED = 'COMPLETED',
  /** Deposit or Withdrawal has been declined */
  DECLINED = 'DECLINED',
  /** Deposit or Withdrawal has failed */
  FAILED = 'FAILED',
  /** Deposit or Withdrawal is in review with an admin */
  IN_REVIEW = 'IN_REVIEW',
  /** Something went wrong during the processing of this Deposit or Withdrawal. Manual admin intervention is required */
  MANUAL_INTERVENTION_REQUIRED = 'MANUAL_INTERVENTION_REQUIRED',
  /** Deposit or Withdrawal has not been reviewed yet */
  PENDING = 'PENDING',
  /** User is required to complete additional actions before payment can be processed */
  PENDING_USER_ACTION = 'PENDING_USER_ACTION',
  /** Deposit or Withdrawal is being processed */
  PROCESSING = 'PROCESSING',
  /** Deposit or Withdrawal has been refunded */
  REFUNDED = 'REFUNDED',
  /** Deposit or Withdrawal has been rejected */
  REJECTED = 'REJECTED'
}

export type AddFundsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<PaypalTransactionProcessInput>;
}>;


export type AddFundsMutation = { __typename?: 'RootMutationType', paypalTransactionProcess?: { __typename?: 'UserMutationOutput', errors?: { __typename?: 'Errors', message?: string | null, fields?: Array<string | null> | null } | null, result?: { __typename?: 'User', id: string } | null } | null };

export type SubmitDepositAdditionalDetailsMutationVariables = Exact<{
  provider: ProviderEnum;
  providerDepositAdditionalDetails: Scalars['String'];
  providerRef: Scalars['String'];
  transactionId: Scalars['String'];
}>;


export type SubmitDepositAdditionalDetailsMutation = { __typename?: 'RootMutationType', submitDepositAdditionalDetails?: { __typename?: 'DepositResponse', amount: number, providerResponse?: string | null, providerReversalResponse?: string | null, mostRecentStatus: { __typename?: 'Status', status: WithdrawalStatus } } | null };

export type SubmitDepositMutationVariables = Exact<{
  amount: Scalars['Int'];
  provider: ProviderEnum;
  providerDepositDetails: ProviderDetailsInput;
  depositFeeAmount?: InputMaybe<Scalars['Int']>;
  savePaymentMethod: Scalars['Boolean'];
}>;


export type SubmitDepositMutation = { __typename?: 'RootMutationType', submitDeposit?: { __typename?: 'DepositResponse', id: string, amount: number, providerResponse?: string | null, providerReversalResponse?: string | null, providerReference?: string | null, mostRecentStatus: { __typename?: 'Status', status: WithdrawalStatus } } | null };

export type DepositMethodFragment = { __typename?: 'DepositProviderResponse', provider: ProviderEnum, platform: PlatformEnum, transferType: string, enabled: boolean, min: string, max: string, paymentMethods: Array<{ __typename?: 'PaymentMethod', brands?: Array<string> | null, name: string, type: string, configuration?: { __typename?: 'AdyenPaymentMethodConfiguration', clientId?: string | null, intent?: string | null, merchantId?: string | null, merchantName?: string | null, scopeId?: string | null } | null }>, storedPaymentMethods?: Array<{ __typename?: 'StoredPaymentMethod', bankAccountNumber?: string | null, bankLocationId?: string | null, brand?: string | null, expiryMonth?: string | null, expiryYear?: string | null, holderName?: string | null, isLastUsedPaymentMethod: boolean, iban?: string | null, id: string, label?: string | null, lastFour?: string | null, name: string, shopperEmail?: string | null, supportedRecurringProcessingModels?: Array<string> | null, supportedShopperInteractions?: Array<string> | null, type: string }> | null };

export type GetDepositMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepositMethodsQuery = { __typename?: 'RootQueryType', getDepositMethods?: Array<{ __typename?: 'DepositProviderResponse', provider: ProviderEnum, platform: PlatformEnum, transferType: string, enabled: boolean, min: string, max: string, paymentMethods: Array<{ __typename?: 'PaymentMethod', brands?: Array<string> | null, name: string, type: string, configuration?: { __typename?: 'AdyenPaymentMethodConfiguration', clientId?: string | null, intent?: string | null, merchantId?: string | null, merchantName?: string | null, scopeId?: string | null } | null }>, storedPaymentMethods?: Array<{ __typename?: 'StoredPaymentMethod', bankAccountNumber?: string | null, bankLocationId?: string | null, brand?: string | null, expiryMonth?: string | null, expiryYear?: string | null, holderName?: string | null, isLastUsedPaymentMethod: boolean, iban?: string | null, id: string, label?: string | null, lastFour?: string | null, name: string, shopperEmail?: string | null, supportedRecurringProcessingModels?: Array<string> | null, supportedShopperInteractions?: Array<string> | null, type: string }> | null } | null> | null };

export type UserFragment = { __typename?: 'User', id: string, phone?: string | null, email?: string | null, idVerificationStatus?: VerificationStatus | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, phone?: string | null, email?: string | null, idVerificationStatus?: VerificationStatus | null } | null };

export const DepositMethodFragmentDoc = gql`
    fragment DepositMethod on DepositProviderResponse {
  provider
  platform
  transferType
  enabled
  min
  max
  paymentMethods {
    brands
    configuration {
      clientId
      intent
      merchantId
      merchantName
      scopeId
    }
    name
    type
  }
  storedPaymentMethods {
    bankAccountNumber
    bankLocationId
    brand
    expiryMonth
    expiryYear
    holderName
    isLastUsedPaymentMethod
    iban
    id
    label
    lastFour
    name
    shopperEmail
    supportedRecurringProcessingModels
    supportedShopperInteractions
    type
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  phone
  email
  idVerificationStatus
}
    `;
export const AddFundsDocument = gql`
    mutation AddFunds($id: ID, $input: PaypalTransactionProcessInput) {
  paypalTransactionProcess(id: $id, input: $input) {
    errors {
      message
      fields
    }
    result {
      id
    }
  }
}
    `;
export type AddFundsMutationFn = Apollo.MutationFunction<AddFundsMutation, AddFundsMutationVariables>;

/**
 * __useAddFundsMutation__
 *
 * To run a mutation, you first call `useAddFundsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFundsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFundsMutation, { data, loading, error }] = useAddFundsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFundsMutation(baseOptions?: Apollo.MutationHookOptions<AddFundsMutation, AddFundsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFundsMutation, AddFundsMutationVariables>(AddFundsDocument, options);
      }
export type AddFundsMutationHookResult = ReturnType<typeof useAddFundsMutation>;
export type AddFundsMutationResult = Apollo.MutationResult<AddFundsMutation>;
export type AddFundsMutationOptions = Apollo.BaseMutationOptions<AddFundsMutation, AddFundsMutationVariables>;
export const SubmitDepositAdditionalDetailsDocument = gql`
    mutation SubmitDepositAdditionalDetails($provider: ProviderEnum!, $providerDepositAdditionalDetails: String!, $providerRef: String!, $transactionId: String!) {
  submitDepositAdditionalDetails(
    provider: $provider
    providerDepositAdditionalDetails: $providerDepositAdditionalDetails
    providerRef: $providerRef
    transactionId: $transactionId
  ) {
    amount
    mostRecentStatus {
      status
    }
    providerResponse
    providerReversalResponse
  }
}
    `;
export type SubmitDepositAdditionalDetailsMutationFn = Apollo.MutationFunction<SubmitDepositAdditionalDetailsMutation, SubmitDepositAdditionalDetailsMutationVariables>;

/**
 * __useSubmitDepositAdditionalDetailsMutation__
 *
 * To run a mutation, you first call `useSubmitDepositAdditionalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDepositAdditionalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDepositAdditionalDetailsMutation, { data, loading, error }] = useSubmitDepositAdditionalDetailsMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      providerDepositAdditionalDetails: // value for 'providerDepositAdditionalDetails'
 *      providerRef: // value for 'providerRef'
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useSubmitDepositAdditionalDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDepositAdditionalDetailsMutation, SubmitDepositAdditionalDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDepositAdditionalDetailsMutation, SubmitDepositAdditionalDetailsMutationVariables>(SubmitDepositAdditionalDetailsDocument, options);
      }
export type SubmitDepositAdditionalDetailsMutationHookResult = ReturnType<typeof useSubmitDepositAdditionalDetailsMutation>;
export type SubmitDepositAdditionalDetailsMutationResult = Apollo.MutationResult<SubmitDepositAdditionalDetailsMutation>;
export type SubmitDepositAdditionalDetailsMutationOptions = Apollo.BaseMutationOptions<SubmitDepositAdditionalDetailsMutation, SubmitDepositAdditionalDetailsMutationVariables>;
export const SubmitDepositDocument = gql`
    mutation SubmitDeposit($amount: Int!, $provider: ProviderEnum!, $providerDepositDetails: ProviderDetailsInput!, $depositFeeAmount: Int, $savePaymentMethod: Boolean!) {
  submitDeposit(
    amount: $amount
    provider: $provider
    providerDepositDetails: $providerDepositDetails
    depositFeeAmount: $depositFeeAmount
    savePaymentMethod: $savePaymentMethod
  ) {
    id
    amount
    mostRecentStatus {
      status
    }
    providerResponse
    providerReversalResponse
    providerReference
  }
}
    `;
export type SubmitDepositMutationFn = Apollo.MutationFunction<SubmitDepositMutation, SubmitDepositMutationVariables>;

/**
 * __useSubmitDepositMutation__
 *
 * To run a mutation, you first call `useSubmitDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDepositMutation, { data, loading, error }] = useSubmitDepositMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      provider: // value for 'provider'
 *      providerDepositDetails: // value for 'providerDepositDetails'
 *      depositFeeAmount: // value for 'depositFeeAmount'
 *      savePaymentMethod: // value for 'savePaymentMethod'
 *   },
 * });
 */
export function useSubmitDepositMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDepositMutation, SubmitDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDepositMutation, SubmitDepositMutationVariables>(SubmitDepositDocument, options);
      }
export type SubmitDepositMutationHookResult = ReturnType<typeof useSubmitDepositMutation>;
export type SubmitDepositMutationResult = Apollo.MutationResult<SubmitDepositMutation>;
export type SubmitDepositMutationOptions = Apollo.BaseMutationOptions<SubmitDepositMutation, SubmitDepositMutationVariables>;
export const GetDepositMethodsDocument = gql`
    query GetDepositMethods {
  getDepositMethods {
    ...DepositMethod
  }
}
    ${DepositMethodFragmentDoc}`;

/**
 * __useGetDepositMethodsQuery__
 *
 * To run a query within a React component, call `useGetDepositMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepositMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepositMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepositMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepositMethodsQuery, GetDepositMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepositMethodsQuery, GetDepositMethodsQueryVariables>(GetDepositMethodsDocument, options);
      }
export function useGetDepositMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepositMethodsQuery, GetDepositMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepositMethodsQuery, GetDepositMethodsQueryVariables>(GetDepositMethodsDocument, options);
        }
export type GetDepositMethodsQueryHookResult = ReturnType<typeof useGetDepositMethodsQuery>;
export type GetDepositMethodsLazyQueryHookResult = ReturnType<typeof useGetDepositMethodsLazyQuery>;
export type GetDepositMethodsQueryResult = Apollo.QueryResult<GetDepositMethodsQuery, GetDepositMethodsQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;